// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormLabel from "@mui/material/FormLabel"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import BreadcrumbComponent from "./BreadcrumbComponent";
import FormComponent from "./FormComponent";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { formatPhone, generateGUID } from "../../../../utils/formatUtils";
import {
  addAdministration,
  addbenificialsOfficers,
  addcontrollingOfficer,
  addIsBenificialneededState,
  addIsThisBenificialOwnerCoState,
  addIsThisBenificialOwnerState,
  addKycError,
  addSelectedExistingBeneficialOwner,
  addSelectedExistingUser,
  addUpdateFlow,
  getExistingUser,
  getRegisterdInvestors,
  initialResetState,
  registerUser,
  setBenificialIds,
  SetCheckEmail,
  setLoginUserdetails,
} from "../../../../redux/slice/userSlice";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useDispatch, useSelector } from "react-redux";
import { kybInvestorId } from "../../../../redux/slice/businessSlice";
import {
  getKycDetails,
  postKycDetails,
} from "../../../../redux/slice/ledgerSlice";
import { useMsal } from "@azure/msal-react";
import {
  formFieldsByStep,
  normalizeUserData,
  validateField,
} from "./businessInfoDetails";
import Loading from "../../../Loading";
import { kybRegisterAPi } from "../../../../redux/slice/kybSlice";
import { toast } from "react-toastify";
import ButtonComponents from "../../../commonComponents/ButtonComponents";
import { textColor } from "../../../../utils/commonstyle";
import { CheckEmail, Errors, ValidationErrors } from "./interface";
import { CircularProgress, Divider, Select, MenuItem, FormHelperText } from "@mui/material";
import { PurchaseProfile } from "@/pages/MyProfile/PurchaseProfile";

const PurchaseProfileBusinessInfo = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);
  const [openLoader, setOpenLoader] = useState(false)
  const [openErrorModel, setOpenErrorModel] = useState(false)
  const [regInvestorId, setRegInvestorId] = useState("")
  const [investorIdForPII, setInvestorIdForPII] = useState("")
  const { id } = useParams();
  const {
    isBenificial,
    bussinessUserdata,
    Administration,
    controllingOfficer,
    benificialsOfficers,
    checkEmail,
    businessInvestorAdminstration,
    businessInvestorControllingID,
    loginUserDetails,
    loginInvestorId,
    loginUserId,
    userData,
    radioControllingState,
    isBenificialneededState,
    isThisBenificialOwnerCoState,
    isThisBenificialOwnerState,
    kycInvestorErrorState,
    isUpdateFlow,
    benificialPercentage,
  } = useSelector((state) => state.user);
  let {
    IsControllingOfficerIsAdmin = null,
    IsBeneficialOwnerIsControllingOfficer = null,
    IsBeneficialOwnerIsAdmin = null,
    IsBeneficialOwnerHaveOwnerShip = null,
  } = loginUserDetails?.BusinessDetailsResponse || {};

  const updatedInvestorId = localStorage.getItem('updatedInvestorId')

  const adminEmail = loginUserDetails?.UserType === 'business' ? loginUserDetails.BusinessAccounts[0]?.Email : loginUserDetails?.Email
  const [radioControllling, setRadioControlling] = useState(false);
  const [isThisBenificialOwner, setIsThisBenificialOwner] = useState(null);
  const [isThisBenificialOwnerCo, setIsThisBenificialOwnerCO] = useState(null);
  const [HideControllingOfficer, setHideControllingOfficer] = useState(false)
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const prevValuesRef = useRef({});
  const { responseData } = useSelector((state) => state?.user);
  const [selectedExistingUser, setSelectedExistingUser] = useState(null);
  const [selectedExistingBeneficialOwner, setSelectedExistingBeneficialOwner] = useState(null);
  const [existingUserLoading, setExistingUserLoading] = useState(false);
  const [selectError, setSelectError] = useState({
    controllingOfficer: "",
    benificialsOfficers: "",
    selectboisadmin: "",
    selectboisco: ""
  })

  useEffect(() => {
    userData?.purchaseProfile?.forEach((profile: any) => {
      if (profile.InvestorId == id) {
        setRadioControlling(profile?.BusinessDetailsResponse?.IsControllingOfficerIsAdmin);
        setIsThisBenificialOwner(profile?.BusinessDetailsResponse?.IsBeneficialOwnerIsAdmin ? "yes" : "no");
        setIsThisBenificialOwnerCO(
          profile?.BusinessDetailsResponse?.IsBeneficialOwnerIsControllingOfficer ? "yes" : "no"
        );
      }
    })
  }, [id])


  const [isKycChecked, setIsKycChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [shift, setShift] = useState(false);
  const [timeOut, setTimeOutDetails] = useState(10000);
  const [kycInvestorError, setKycInvestorError] = useState<any>({
    Administrator: {},
    "Controlling Officer": {},
    "Beneficial Owner": [{}],
  });
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const msalInstance: any = instance;
  const currentPath = window.location.pathname;
  const isPurchaseProfile = currentPath.includes("purchaseprofile");
  const steps = isBenificial
    ? (isPurchaseProfile ? ["Controlling Officer", "Beneficial Owner"] : ["Administrator", "Controlling Officer", "Beneficial Owner"])
    : (isPurchaseProfile ? ["Controlling Officer"] : ["Administrator", "Controlling Officer"]);
  const activeAccount = msalInstance.getActiveAccount();

  const [dialogOpen, setDialogOpen] = useState(false);
  const AdminId = loginUserDetails?.UserType == "individual" ? loginInvestorId : loginUserDetails.BusinessAccounts.InvestorId


  const claims = activeAccount?.idTokenClaims;
  const [formData, setFormData] = useState({
    Administrator: {
      investorId: 0,
      firstName: "",
      lastName: "",
      address: "",
      city: "",
      state: "",
      zipCode: "",
      dateOfBirth: "",
      socialSecurityNumber: "",
      email: claims?.email,
      phone: "",
      documentType: "",
      documentId: "",
      documentCountry: "",
      documentState: "",
      IsExistingUser: false,
      existingInvestorId: 0
    },
    "Controlling Officer": {
      investorId: 0,
      firstName: "",
      lastName: "",
      address: "",
      city: "",
      state: "",
      zipCode: "",
      dateOfBirth: "",
      socialSecurityNumber: "",
      email: "",
      phone: "",
      documentState: "",
      documentCountry: "",
      documentId: "",
      documentType: "",
      IsExistingUser: false,
      existingInvestorId: 0
    },
    "Beneficial Owner": [
      {
        investorId: 0,
        firstName: "",
        lastName: "",
        address: "",
        city: "",
        state: "",
        zipCode: "",
        dateOfBirth: "",
        socialSecurityNumber: "",
        email: "",
        phone: "",
        percentOwnership: benificialPercentage === 100 ? `${benificialPercentage}` : "",
        documentState: "",
        documentCountry: "",
        documentId: "",
        documentType: "",
        IsExistingUser: false,
        existingInvestorId: 0
      },
    ],
  });

  const [apiData, setApiData] = useState({
    adminData: {},
    controllingOfficer: {},
    benificialsOfficer: [{}],
  });

  useEffect(() => {
    setSelectedExistingBeneficialOwner(null)
  }, [isThisBenificialOwner, isThisBenificialOwnerCo])

  const firstName = loginUserDetails?.UserType === "business" ? loginUserDetails?.BusinessAccounts[0].FirstName : loginUserDetails?.FirstName
  const lastName = loginUserDetails?.UserType === "business" ? loginUserDetails?.BusinessAccounts[0].LastName : loginUserDetails?.LastName
 
  useEffect(() => {
    const updatedFormData = { ...formData };
 if (isPurchaseProfile && !id) {
      updatedFormData.Administrator = {
        ...updatedFormData.Administrator,
        investorId: parseInt(bussinessUserdata?.investorId) || 0,
        firstName: claims?.given_name || firstName,
        lastName: claims?.family_name || lastName,
        email: bussinessUserdata?.Email || "",
        ...(isPurchaseProfile && {
          address: loginUserDetails?.DeliveryLine || "",
          city: loginUserDetails?.City || "",
          state: loginUserDetails?.State || "",
          zipCode: loginUserDetails?.zipCode || "",
          email: adminEmail || "",
        }),
        ...(isPurchaseProfile && id && {
          socialSecurityNumber: "777777777",
          dateOfBirth: "2007-01-01",
          email: adminEmail || "",
        }),
        phone: bussinessUserdata?.Phone?.replace(/\D/g, "") || "",
        documentId: bussinessUserdata?.DocumentId || "",
        documentType: bussinessUserdata?.DocumentType || "",
        documentState: bussinessUserdata?.DocumentState || "",
        documentCountry: bussinessUserdata?.DocumentCountry || "",
        IsExistingUser: false,
      };
    }

    const newFormData = { ...updatedFormData };
    setFormData(newFormData);

  }, [bussinessUserdata, loginUserDetails])

  useEffect(() => {
    if (isUpdateFlow) return
    const updatedFormData = { ...formData };
    let isAdminCO = false;
    let isAdminOwner = "no"
    let isAdminBO = null
    let isControllingBO = null
    userData?.purchaseProfile?.forEach((profile: any) => {
      if (profile.InvestorId == id) {
        isAdminCO = profile?.BusinessDetailsResponse?.IsControllingOfficerIsAdmin;
        isAdminOwner = profile?.BusinessDetailsResponse?.IsBeneficialOwnerHaveOwnerShip ? "yes" : "no"
        isAdminBO = profile?.BusinessDetailsResponse?.IsBeneficialOwnerIsAdmin ? "yes" : "no"
        isControllingBO = profile?.BusinessDetailsResponse?.IsBeneficialOwnerIsControllingOfficer ? "yes" : "no"
        profile?.BusinessChildAccounts?.forEach((account) => {
          // Check for Administrator
          validateFormData(account.BusinessUserType);
          if (account.BusinessUserType === "administrator") {
            updatedFormData.Administrator = {
              ...updatedFormData.Administrator,
              investorId: parseInt(account.InvestorId), // Default to an empty string if no value
              firstName: account.FirstName || "",
              lastName: account.LastName || "",
              email: account.Email || "",
              ...(isPurchaseProfile && {
                address: account.DeliveryLine,
                city: account.City || "",
                state: account.State || "",
                zipCode: account.ZipCode || "",
                email: adminEmail || "",
              }),
              ...(isPurchaseProfile && id && {
                socialSecurityNumber: "777777777",
                dateOfBirth: "2007-01-01",
                email: adminEmail || "",
              }),
              phone: account.Phone.replaceAll("-", "") || "",
              documentId: account?.DocumentId || "",
              documentType: account?.DocumentType || "",
              documentState: account?.DocumentState || "",
              documentCountry: account?.DocumentCountry || "",
              IsExistingUser: false


              // Add any additional fields if needed
            };
          }

          // Check for Controlling Officer
          else if (account.BusinessUserType === "controlling_officer") {
            if (selectedExistingUser == '' || selectedExistingBeneficialOwner == '') return null;
            validateUpdateError(account, profile?.BusinessDetailsResponse)
            updatedFormData["Controlling Officer"] = {
              ...updatedFormData["Controlling Officer"],
              investorId: parseInt(account?.InvestorId),
              address: account.DeliveryLine,
              firstName: account.FirstName || "",
              lastName: account.LastName || "",
              city: account.City || "",
              state: account.State || "",
              zipCode: account.ZipCode || "",
              email: account.Email || "",
              phone: account.Phone.replaceAll("-", "") || "",
              documentId: account?.DocumentId || "",
              documentType: account?.DocumentType || "",
              documentState: account?.DocumentState || "",
              documentCountry: account?.DocumentCountry || "",
              // investorId: parseInt(account.InvestorId) || parseInt(account.investorId) ||  0,
              ...((isPurchaseProfile && id && profile?.BusinessDetailsResponse?.IsControllingOfficerIsAdmin) && {
                socialSecurityNumber: "777777777",
                dateOfBirth: "2007-01-01",
                email: adminEmail,
                documentId: "77777777",
              }),

            };
          }
          // Check for Beneficial Owner
          else if (account.BusinessUserType === "beneficial_owner") {
            // Ensure that Beneficial Owner array is initialized
            if (!updatedFormData["Beneficial Owner"]) {
              updatedFormData["Beneficial Owner"] = [];
            }

            updatedFormData["Beneficial Owner"] = updatedFormData[
              "Beneficial Owner"
            ].filter((owner) => owner.investorId !== 0);

            // Add new Beneficial Owner data only if the investorId is not 0 and it doesn't already exist
            if (account?.InvestorId !== 0) {
              validateUpdateError(account, profile?.BusinessDetailsResponse)
              updatedFormData["Beneficial Owner"].push({
                investorId: parseInt(account.InvestorId) || 0,
                firstName: account.FirstName || "",
                lastName: account.LastName || "",
                city: account.City || "",
                address: account.DeliveryLine,
                state: account.State || "",
                zipCode: account.ZipCode || "",
                email: account.Email || "",
                phone: account.Phone.replaceAll("-", "") || "",
                documentId: account?.DocumentId || "",
                documentType: account?.DocumentType || "",
                documentState: account?.DocumentState || "",
                documentCountry: account?.DocumentCountry || "",
                IsExistingUser: false,

                ...(((isPurchaseProfile && id && isThisBenificialOwner == 'yes' && isThisBenificialOwnerCo == 'no') ||
                  (isPurchaseProfile && id && isThisBenificialOwner == "no" && isThisBenificialOwnerCo == 'yes'))
                  ? {
                    socialSecurityNumber: "777777777",
                    dateOfBirth: "2007-01-01",
                    email: adminEmail
                  }
                  : {}),


                percentOwnership: benificialPercentage === 100 ? `${benificialPercentage}` : '', // Placeholder for percent ownership
              });
            }
          }
        });

      }
    });
    const newFormData = { ...updatedFormData };
    if (isPurchaseProfile) {
      dispatch(addAdministration(updatedFormData["Administrator"]))
      // dispatch(addbenificialsOfficers(updatedFormData["Beneficial Owner"]))
      dispatch(addbenificialsOfficers({
        data: updatedFormData["Beneficial Owner"],
        isThisBenificialOwnerCo: isControllingBO,
        isThisBenificialOwner: isAdminBO
      }));
      dispatch(addcontrollingOfficer({ data: updatedFormData["Controlling Officer"], isChecked: isAdminCO }))
      dispatch(addUpdateFlow(true))
    }
    setFormData(newFormData);


  }, [userData, radioControllling, isThisBenificialOwner, isThisBenificialOwnerCo, selectedExistingUser]);
  const updateFormData = () => {
    // Create a copy of formData to update
    const updatedFormData = { ...formData };
    loginUserDetails?.BusinessAccounts?.forEach((account) => {
      // Check for Administrator
      validateFormData(account.BusinessUserType);
      if (account.BusinessUserType === "administrator") {
        validateUpdateError(account, loginUserDetails?.BusinessDetailsResponse)
        updatedFormData.Administrator = {
          ...updatedFormData.Administrator,
          investorId: parseInt(account.InvestorId) || 0, // Default to an empty string if no value
          firstName: account.FirstName || "",
          lastName: account.LastName || "",
          city: account.City || "",
          state: account.State || "",
          zipCode: account.ZipCode || "",
          email: account.Email || "",
          phone: account.Phone.replaceAll("-", "") || "",
          address: account.DeliveryLine,
          documentId: account?.DocumentId || "",
          documentType: account?.DocumentType || "",
          documentState: account?.DocumentState || "",
          documentCountry: account?.DocumentCountry || "",
          IsExistingUser: false,



          // Add any additional fields if needed
        };

      }
      // Check for Controlling Officer
      else if (account.BusinessUserType === "controlling_officer") {
        validateUpdateError(account, loginUserDetails?.BusinessDetailsResponse)
        updatedFormData["Controlling Officer"] = {
          ...updatedFormData["Controlling Officer"],
          investorId: parseInt(account.InvestorId) || 0,
          address: account.DeliveryLine,
          firstName: account.FirstName || "",
          lastName: account.LastName || "",
          city: account.City || "",
          state: account.State || "",
          zipCode: account.ZipCode || "",
          email: account.Email || "",
          phone: account.Phone.replaceAll("-", "") || "",
          socialSecurityNumber: isPurchaseProfile && "777777777",
          dateOfBirth: isPurchaseProfile && "2007-01-01",
          documentId: account?.DocumentId || "",
          documentType: account?.DocumentType || "",
          documentState: account?.DocumentState || "",
          documentCountry: account?.DocumentCountry || "",
          IsExistingUser: false,

        };
      }

      // Check for Beneficial Owner
      else if (account.BusinessUserType === "beneficial_owner") {
        // Ensure that Beneficial Owner array is initialized
        if (!updatedFormData["Beneficial Owner"]) {
          updatedFormData["Beneficial Owner"] = [];
        }

        updatedFormData["Beneficial Owner"] = updatedFormData[
          "Beneficial Owner"
        ].filter((owner) => owner.investorId !== 0);

        // Check if the InvestorId is not 0 and already exists in the Beneficial Owner array
        const filteredOwners = updatedFormData["Beneficial Owner"].filter(
          (owner) => String(owner.investorId) === String(account.InvestorId)
        );
        const isInvestorIdExist = filteredOwners?.length > 0;

        const errordataTemp = [];

        // Add new Beneficial Owner data only if the investorId is not 0 and it doesn't already exist
        if (account?.InvestorId !== 0) {
          validateUpdateError(account, loginUserDetails?.BusinessDetailsResponse)
          updatedFormData["Beneficial Owner"].push({
            investorId: parseInt(account.InvestorId) || 0,
            firstName: account.FirstName || "",
            lastName: account.LastName || "",
            city: account.City || "",
            address: account.DeliveryLine,
            state: account.State || "",
            zipCode: account.ZipCode || "",
            email: account.Email || "",
            phone: account.Phone.replaceAll("-", "") || "",
            socialSecurityNumber: "",
            dateOfBirth: "",
            documentId: account?.DocumentId || "",
            documentType: account?.DocumentType || "",
            documentState: account?.DocumentState || "",
            documentCountry: account?.DocumentCountry || "",
            percentOwnership: benificialPercentage === 100 ? `${benificialPercentage}` : "", // Placeholder for percent ownership
            IsExistingUser: false,

          });
        }
      }
    });

    dispatch(addAdministration(updatedFormData["Administrator"]))
    const isBN = IsBeneficialOwnerHaveOwnerShip ? "yes" : "no"
    const BenificialOwnerCo = IsBeneficialOwnerIsControllingOfficer ? "yes" : "no"
    const BenificialOwner = IsBeneficialOwnerIsAdmin ? "yes" : "no"
    dispatch(addbenificialsOfficers({
      data: updatedFormData["Beneficial Owner"],
      isThisBenificialOwnerCo: BenificialOwnerCo,
      isThisBenificialOwner: BenificialOwner
    }));
    dispatch(addcontrollingOfficer({ data: updatedFormData["Controlling Officer"], isChecked: IsControllingOfficerIsAdmin }))
    dispatch(addUpdateFlow(true))

    // Update the formData state with the new data
    const newFormData = { ...updatedFormData };
    setFormData(newFormData);

  };

  useEffect(() => {
    if (loginInvestorId && !isPurchaseProfile && !id) {
      if (isUpdateFlow) return
      updateFormData();
    } else {
      validateFormData(formData);
    }
  }, [])

  const isUserTypeBusiness = loginUserDetails?.UserType == "business"
  const isUserTypeIndividual = loginUserDetails?.UserType == "individual"

  useEffect(() => {
    if ((!loginInvestorId || isPurchaseProfile) && !id || isUpdateFlow) {
      setFormData((prev) => {

        return {
          Administrator: {
            investorId: parseInt(Administration?.investorId) || 0,
            firstName: Administration?.firstName || claims?.given_name || firstName,
            lastName: Administration?.lastName || claims?.family_name || lastName,
            dateOfBirth: Administration?.dateOfBirth || bussinessUserdata?.DateOfBirth,
            socialSecurityNumber: Administration?.socialSecurityNumber || bussinessUserdata?.SocialSecurityNumber,
            email: Administration?.email || claims?.email || bussinessUserdata?.Email || "",
            phone: Administration?.phone || bussinessUserdata?.phone?.replace(/\D/g, "") || claims?.extension_phoneNumber || loginUserDetails?.Phone || "",
            address: Administration?.address || "",
            city: Administration?.city || "",
            state: Administration?.state || "",
            zipCode: Administration?.zipCode || "",
            documentId: Administration?.documentId || loginUserDetails?.BusinessAccounts?.[0]?.DocumentId || "",
            documentType: Administration?.documentType || loginUserDetails?.BusinessAccounts?.[0]?.DocumentType || "",
            documentState: Administration?.documentState || loginUserDetails?.BusinessAccounts?.[0]?.DocumentState || "",
            documentCountry: Administration?.documentCountry || loginUserDetails?.BusinessAccounts?.[0]?.DocumentCountry || "",
            IsExistingUser: false,
            ...((isPurchaseProfile && isUserTypeIndividual) && {
              socialSecurityNumber: "777777777",
              dateOfBirth: "2007-01-01",
              email: adminEmail,
              address: loginUserDetails?.DeliveryLine || "",
              city: loginUserDetails?.City || "",
              state: loginUserDetails?.State || "",
              zipCode: loginUserDetails?.ZipCode || "",
              documentId: "77777777",
              existingInvestorId: loginUserDetails.InvestorId || 0,
              documentType: loginUserDetails?.DocumentType || "",
              documentState: loginUserDetails?.DocumentState || "",
              documentCountry: loginUserDetails?.DocumentCountry || "",
              IsExistingUser: false,

            }),
            ...((isPurchaseProfile && isUserTypeBusiness) && {
              socialSecurityNumber: "777777777",
              dateOfBirth: "2007-01-01",
              email: adminEmail,
              address: loginUserDetails?.BusinessAccounts[0]?.DeliveryLine || "",
              city: loginUserDetails?.BusinessAccounts[0]?.City || "",
              state: loginUserDetails?.BusinessAccounts[0]?.State || "",
              zipCode: loginUserDetails?.BusinessAccounts[0]?.ZipCode || "",
              existingInvestorId: loginUserDetails?.BusinessAccounts[0]?.InvestorId || 0,
              documentId: "77777777",
              documentType: loginUserDetails?.BusinessAccounts[0]?.DocumentType || "",
              documentState: loginUserDetails?.BusinessAccounts[0]?.DocumentState || "",
              documentCountry: loginUserDetails?.BusinessAccounts[0]?.DocumentCountry || "",
              IsExistingUser: false,

            }),
          },

          "Controlling Officer": (radioControllingState && !isPurchaseProfile) ? {
            ...prev["Controlling Officer"]
          } : {
            investorId: parseInt(controllingOfficer?.investorId) || 0,
            firstName: controllingOfficer?.firstName || "",
            lastName: controllingOfficer?.lastName || "",
            address: controllingOfficer?.address || "",
            city: controllingOfficer?.city || "",
            state: controllingOfficer?.state || "",
            zipCode: controllingOfficer?.zipCode || "",
            dateOfBirth: controllingOfficer?.dateOfBirth || "",
            socialSecurityNumber: controllingOfficer?.socialSecurityNumber || "",
            email: controllingOfficer?.email || "",
            phone: controllingOfficer?.phone || "",
            documentId: controllingOfficer?.documentId !== ""
              ? controllingOfficer.documentId
              : (isPurchaseProfile && radioControllingState === true ? "777777777" : ""),

            documentType: controllingOfficer?.documentType || "",
            documentState: controllingOfficer?.documentState || "",
            documentCountry: controllingOfficer?.documentCountry || "",
            IsExistingUser: false,
            ...((id && (selectedExistingUser !== null && selectedExistingUser !== 'none')) && {
              socialSecurityNumber: "777777788",
              dateOfBirth: "2007-01-01",
              documentId: "77777777 ",
              IsExistingUser: true,

            }),

          },
          "Beneficial Owner": isThisBenificialOwnerCo !== "yes" && isThisBenificialOwner !== "yes" ? benificialsOfficers?.map((beneficial) => ({
            investorId: parseInt(beneficial?.investorId) || 0,
            firstName: beneficial?.firstName || "",
            lastName: beneficial?.lastName || "",
            address: beneficial?.address || "",
            city: beneficial?.city || "",
            state: beneficial?.state || "",
            zipCode: beneficial?.zipCode || "",
            dateOfBirth: beneficial?.dateOfBirth || "",
            socialSecurityNumber: beneficial?.socialSecurityNumber || "",
            email: beneficial?.email || "",
            phone: beneficial?.phone || "",
            percentOwnership: benificialPercentage === 100 ? `${benificialPercentage}` : beneficial?.percentOwnership || "",
            documentId: beneficial?.documentId || "",
            documentType: beneficial?.documentType || "",
            documentState: beneficial?.documentState || "",
            documentCountry: beneficial?.documentCountry || "",
            IsExistingUser: false,
            ...((id && (selectedExistingBeneficialOwner !== 'none' && selectedExistingBeneficialOwner !== null)) && {
              socialSecurityNumber: "777777799",
              dateOfBirth: "2007-01-01",
              documentId: "77777777",
              IsExistingUser: true,

            }),
          })) :
            [...prev["Beneficial Owner"]]
          ,
        }
      });
      setIsThisBenificialOwner(isThisBenificialOwnerState)
      setIsThisBenificialOwnerCO(isThisBenificialOwnerCoState)
      setRadioControlling(radioControllingState)
      setKycInvestorError(kycInvestorErrorState)
      setSelectedExistingUser(controllingOfficer?.selectedExistingUser || null)
      setSelectedExistingBeneficialOwner(benificialsOfficers?.[0]?.selectedExistingBeneficialOwner || null)
    }

  }, [Administration, controllingOfficer, benificialsOfficers, isBenificialneededState, isThisBenificialOwnerState, isThisBenificialOwnerCoState, radioControllingState]); // Depend on Redux state changes

  useEffect(() => {
    if ((!loginInvestorId || isPurchaseProfile) && !id || isUpdateFlow) {
      setKycInvestorError(kycInvestorErrorState)
    }
  }, [kycInvestorErrorState])




  useEffect(() => {
    if (!isPurchaseProfile || radioControllling) return;
    if (selectedExistingUser && selectedExistingUser !== "none") {
      const selectedUser = Array.isArray(responseData?.data)
        ? responseData.data.find(
          (item) =>
            String(item.id || item.investorId) === String(selectedExistingUser)
        )
        : null;
      if (selectedUser) {
        setFormData((prev) => ({
          ...prev,
          "Controlling Officer": {
            ...prev["Controlling Officer"],
            existingInvestorId: selectedUser?.investorId || 0,
            firstName: selectedUser.firstName || "",
            lastName: selectedUser.lastName || "",
            address: selectedUser.deliveryLine || "",
            city: selectedUser.city || "",
            state: selectedUser.state || "",
            zipCode: selectedUser.zipCode || "",
            dateOfBirth: selectedUser.dateOfBirth || "12/07/1995",
            socialSecurityNumber: selectedUser.socialSecurityNumber || "777777777",
            email: selectedUser.email || "",
            phone: selectedUser.phone || "",
            documentId: selectedUser.documentId || "777777777",
            documentType: selectedUser.documentType || "",
            documentState: selectedUser.documentState || "",
            documentCountry: selectedUser.documentCountry || "",
            IsExistingUser: true
          },
        }));
      }
    }
  }, [selectedExistingUser, responseData?.data, isPurchaseProfile, radioControllling]);

  useEffect(() => {
    if (
      steps[currentStep] === "Beneficial Owner" &&
      isThisBenificialOwner === "no" &&
      (
        radioControllling === null
          ? isThisBenificialOwnerCo === "no"
          : true
      )
    ){
      if (selectedExistingBeneficialOwner && selectedExistingBeneficialOwner !== "none") {
        const selectedUser = Array.isArray(responseData?.data)
          ? responseData.data.find(
            (item) =>
              String(item.id || item.investorId) === String(selectedExistingBeneficialOwner)
          )
          : null;
        if (selectedUser) {
          setFormData((prev) => ({
            ...prev,
            "Beneficial Owner": [
              {
                investorId: 0,
                existingInvestorId: selectedUser?.investorId || 0,
                firstName: selectedUser.firstName || "",
                lastName: selectedUser.lastName || "",
                address: selectedUser.deliveryLine || "",
                city: selectedUser.city || "",
                state: selectedUser.state || "",
                zipCode: selectedUser.zipCode || "",
                dateOfBirth: selectedUser.dateOfBirth || "12/07/1995",
                socialSecurityNumber: selectedUser.socialSecurityNumber || "888888888",
                email: selectedUser.email || "",
                phone: selectedUser.phone || "",
                documentId: selectedUser.documentId || "777777777",
                documentType: selectedUser.documentType || "",
                documentState: selectedUser.documentState || "",
                documentCountry: selectedUser.documentCountry || "",
                percentOwnership: benificialPercentage === 100 ? `${benificialPercentage}` : selectedUser?.percentOwnership || benificialsOfficers[0]?.percentOwnership || "",
                IsExistingUser: true,
              },
            ],
          }));
        }
      }
    }
  }, [
    selectedExistingBeneficialOwner,
    responseData?.data,
    isThisBenificialOwner,
    isThisBenificialOwnerCo,
    radioControllling,
  ]);

  const validateFormData = (updatedData: any, stepName: string, fieldName: any): boolean => {
    let updatedErrors: any = Array.isArray(kycInvestorError[stepName])
      ? kycInvestorError[stepName].map(err => ({ ...err })) // deep copy array of objects
      : { ...kycInvestorError[stepName] };
    let isValid = true;

    const stepData = updatedData[stepName];
    const fields = formFieldsByStep[stepName];

    // Ensure fields are defined
    if (!fields || !stepData) {
      return false;
    }

    // --- Custom validation for documentState/documentCountry ---

    if (stepName === "Beneficial Owner" && Array.isArray(stepData)) {
      stepData.forEach((entry, ownerIndex) => {
        // If all fields are blank for this owner, clear errors and skip validation

        const allBlank = Object.values(entry).every(val => val === "" || val == null);
        if (allBlank) {
          updatedErrors[ownerIndex] = {};
          return;
        }
        const hasState = !!entry.documentState;
        const hasCountry = !!entry.documentCountry;
        if (!hasState && !hasCountry) {
          updatedErrors[ownerIndex] = {
            ...(updatedErrors[ownerIndex] || {}),
            documentState: "Document State is required",
            documentCountry: "Document Country is required",
          };
          isValid = false;
        } else if (updatedErrors[ownerIndex]) {
          delete updatedErrors[ownerIndex].documentState;
          delete updatedErrors[ownerIndex].documentCountry;
        }
      });
    }
    // --- End custom validation ---

    if (Array.isArray(stepData)) {
      stepData.forEach((entry, ownerIndex) => {
        // If all fields are blank for this owner, skip further validation
        const allBlank = Object.values(entry).every(val => val === "" || val == null);
        if (allBlank) {
          updatedErrors[ownerIndex] = {};
          return;
        }
        const field = fields.find(f => f.name === fieldName);
        if (!field) return;

        const errorKey = fieldName;
        let errorMessage = "";

        if (fieldName === "socialSecurityNumber") {
          const ssn = entry[fieldName]?.replace(/-/g, "") || "";
          if (!/^\d{9}$/.test(ssn)) {
            if (ssn?.length > 0 || selectedExistingUser) {
              errorMessage = "Social Security Number must be 9 digits";
            }
          } else {
            const [area, group, serial] = [
              ssn.substring(0, 3),
              ssn.substring(3, 5),
              ssn.substring(5, 9),
            ];
            if (
              area === "000" ||
              area === "666" ||
              area.startsWith("9") ||
              group === "00" ||
              serial === "0000"
            ) {
              errorMessage = "SSN is not valid.";
            }
          }
        } else if (fieldName === "dateOfBirth") {
          if (selectedExistingUser || selectedExistingBeneficialOwner) {
            errorMessage = false
          }
          else if (!entry[fieldName]) {
            errorMessage = "Date of Birth is required";
          } else if (entry[fieldName] === "Invalid date") {
            errorMessage = "Invalid Date";
          } else {
            const minAllowedDate = moment().subtract(18, "years").startOf("day");
            const isValidAge = moment(entry[fieldName], "YYYY-MM-DD").isBefore(minAllowedDate);
            if (!isValidAge) {
              errorMessage = "You must be at least 18 years old";
            }
          }

        } else if (fieldName === "percentOwnership") {
          if (entry[fieldName] <= 100 && entry[fieldName] >= benificialPercentage) {
          } else {
            errorMessage = `Ownership percentage must be ${benificialPercentage === 100 ? '100' : 'between 50 and 100'}`
          }
        } else {
          errorMessage = validateField(entry[fieldName], fieldName, benificialPercentage);
        }

        updatedErrors[ownerIndex] = {
          ...(updatedErrors[ownerIndex] || {}),
        };
        if (fieldName === "address" || fieldName === "city" || fieldName === "state" || fieldName === "zipCode") {
          if (entry["address"]?.trim()?.length > 0) {
            delete updatedErrors[ownerIndex]["address"]
          }
          if (entry["city"]?.trim()?.length > 0) {
            delete updatedErrors[ownerIndex]["city"]
          }
          if (entry["state"]?.trim()?.length > 0) {
            delete updatedErrors[ownerIndex]["state"]
          }
          if (entry["zipCode"]?.trim()?.length > 0) {
            delete updatedErrors[ownerIndex]["zipCode"]
          }
        }
        if (errorMessage) {
          updatedErrors[ownerIndex][errorKey] = errorMessage;
          isValid = false;
        } else {
          delete updatedErrors[ownerIndex][errorKey];
        }

        // === BO vs BO Duplicate Check ===
        for (let i = 0; i < stepData?.length; i++) {
          if (i !== ownerIndex) {
            const validationBO = areDetailsUniqueMultiFields(entry, stepData[i]);
            if (!validationBO.valid) {
              validationBO.duplicates.forEach((dup) => {
                updatedErrors[ownerIndex] = {
                  ...(updatedErrors[ownerIndex] || {}),
                  [dup.field]: `Beneficial Owner #${ownerIndex + 1} and Beneficial Owner #${i + 1} cannot have the same ${dup.label}`,
                };

                isValid = false;
              });
            }
          }
        }

        // ✅ Duplicate Check: Controlling Officer vs Beneficial Owner
        if (isThisBenificialOwnerCo !== "yes" && !radioControllling && isThisBenificialOwner !== "yes") {
          const validationCO = areDetailsUniqueMultiFields(
            updatedData["Controlling Officer"],
            entry
          );

          if (!validationCO.valid) {
            validationCO.duplicates.forEach((dup) => {
              updatedErrors[ownerIndex] = {
                ...(updatedErrors[ownerIndex] || {}),
                [dup.field]: `Controlling Officer and Beneficial Owner cannot have the same ${dup.label}`,
              };

              isValid = false;
            });
          }
        }
        // ✅ INSERT DUPLICATE CHECK HERE
        if (isThisBenificialOwner !== "yes" && isThisBenificialOwnerCo !== "yes") {
          const validationAdmin = areDetailsUniqueMultiFields(
            updatedData["Administrator"],
            entry
          );

          if (!validationAdmin.valid) {
            validationAdmin.duplicates.forEach((dup) => {
              updatedErrors[ownerIndex] = {
                ...(updatedErrors[ownerIndex] || {}),
                [dup.field]: `Administrator and Beneficial Owner cannot have the same ${dup.label}`,
              };

              isValid = false;
            });
          }
        }

      });

    } else {
      // For single entries (Administrator, Controlling Officer)
      const field = fields.find(f => f.name === fieldName);
      if (field) {
        if (fieldName === "address" || fieldName === "city" || fieldName === "state" || fieldName === "zipCode") {
          if (stepData["address"]?.trim()?.length > 0) {
            delete updatedErrors["address"]
          }
          if (stepData["city"]?.trim()?.length > 0) {
            delete updatedErrors["city"]
          }
          if (stepData["state"]?.trim().length > 0) {
            delete updatedErrors["state"]
          }
          if (stepData["zipCode"]?.trim()?.length > 0) {
            delete updatedErrors["zipCode"]
          }
        }
        // Handle specific field validations
        if (fieldName === 'socialSecurityNumber') {
          const ssn = stepData[fieldName]?.replace(/-/g, "");
          if (!ssn || !/^\d{9}$/.test(ssn)) {
            updatedErrors[fieldName] = "Social Security Number must be 9 digits";
            if (ssn?.length === 0) {
              delete updatedErrors[fieldName];
            }
            isValid = false;
          } else {
            const area = ssn.substring(0, 3);
            const group = ssn.substring(3, 5);
            const serial = ssn.substring(5, 9);

            if (area === "000" || area === "666" || area.startsWith("9")) {
              updatedErrors[fieldName] = "SSN is not valid.";
              isValid = false;
            } else if (group === "00") {
              updatedErrors[fieldName] = "SSN is not valid.";
              isValid = false;
            } else if (serial === "0000") {
              updatedErrors[fieldName] = "SSN is not valid.";
              isValid = false;
            } else {
              delete updatedErrors[fieldName];
            }
          }
        } else if (fieldName === 'dateOfBirth') {
          if (!stepData[fieldName]) {
            updatedErrors[fieldName] = "Date of Birth is required";
            isValid = false;
          } else if (stepData[fieldName] === "Invalid date") {
            updatedErrors[fieldName] = "Invalid date";
            isValid = false
          }
          else {
            const minAllowedDate = moment().subtract(18, "years").startOf("day");
            const isValidAge = moment(stepData[fieldName], "YYYY-MM-DD").isBefore(minAllowedDate);

            if (!isValidAge) {
              updatedErrors[fieldName] = "You must be at least 18 years old";
            } else {
              delete updatedErrors[fieldName];
            }

          }
        } else {
          const error = validateField(stepData[fieldName], fieldName, benificialPercentage);
          if (error) {
            updatedErrors[fieldName] = error;
            isValid = false;
          } else {
            delete updatedErrors[fieldName];
          }
        }
        if (fieldName === "documentCountry" && stepData.documentCountry) {
          if (updatedErrors) delete updatedErrors.documentState;
        }
        if (fieldName === "documentState" && stepData.documentState) {
          if (updatedErrors) delete updatedErrors.documentCountry;
        }
      }
    }
    setKycInvestorError((prevError) => ({
      ...prevError,
      [stepName]: updatedErrors
    }))
    return isValid;
  };
  const validateSSN = (step, businessResponse) => {
    if (step == "controlling_officer") {
      if (businessResponse?.IsControllingOfficerIsAdmin) {
        // return formData["Administrator"]["socialSecurityNumber"].length !== 9
        //   ? "Social Security Number must be 9 digits."
        //   : null;
      } else {
        return formData["Controlling Officer"]["socialSecurityNumber"]?.length !== 9
          ? "Social Security Number must be 9 digits."
          : null;

      }
    } else if (step == "beneficial_owner") {
      if (businessResponse?.IsBeneficialOwnerIsAdmin) {
      } else if (businessResponse?.IsBeneficialOwnerIsControllingOfficer) {
      } else {
        if (formData["Administrator"]["socialSecurityNumber"] === formData["Beneficial Owner"][0]["socialSecurityNumber"] && formData["Beneficial Owner"][0]["socialSecurityNumber"]?.length > 0) {
          return "Administrator and Beneficial Owner #1 cannot have the same Social Security Number";
        } else if (formData["Controlling Officer"]["socialSecurityNumber"] === formData["Beneficial Owner"][0]["socialSecurityNumber"] && formData["Beneficial Owner"][0]["socialSecurityNumber"]?.length > 0) {
          return "Controlling Officer and Beneficial Owner #1 cannot have the same Social Security Number";
        } else if (!businessResponse?.IsBeneficialOwnerIsAdmin && !businessResponse?.IsBeneficialOwnerIsControllingOfficer) {
          return formData["Beneficial Owner"][0]["socialSecurityNumber"]?.length !== 9
            ? "Social Security Number must be 9 digits."
            : null;
        }
      }
    }
  };
  const validateUpdateError = (account, businessResponse) => {
    if (account.BusinessUserType === "administrator") {
      const errorData = {
        ...kycInvestorError.Administrator,
        lastName:
          account.DocumentRequiredFor?.includes("full_name") &&
          "OFAC sanctions match",
        email: account.DocumentRequiredFor?.includes("email") && "Email risk",
        phone: account.DocumentRequiredFor?.includes("phone") && "Phone risk",
        socialSecurityNumber:
          account.DocumentRequiredFor?.includes("ssn") && formData["Administrator"]["socialSecurityNumber"] == "" ? "SSN did not matched" : formData["Administrator"]["socialSecurityNumber"] === "" &&
            "Social Security Number must be 9 digits.",
        address:
          account.DocumentRequiredFor?.includes("address") &&
          "Address did not match",
        dateOfBirth:
          account.DocumentRequiredFor?.includes("birthdate") ?
            "Birthdate did not match" : formData["Administrator"]["dateOfBirth"] === "" &&
            "Date of Birth is required",
        zipCode: account.DocumentRequiredFor?.includes("address") && true,
        city: account.DocumentRequiredFor?.includes("address") && true,
        state: account.DocumentRequiredFor?.includes("address") && true,
      };

      // Update Administrator information
      setKycInvestorError((prevState) => ({
        ...prevState,
        Administrator: errorData,
      }));
    }
    // Check for Controlling Officer
    else if (account.BusinessUserType === "controlling_officer") {
      const errorData = {
        ...errors,
        lastName:
          account.DocumentRequiredFor?.includes("full_name") &&
          "OFAC sanctions match",
        email: account.DocumentRequiredFor?.includes("email") && "Email risk",
        phone: account.DocumentRequiredFor?.includes("phone") && "Phone risk",
        socialSecurityNumber:
          account.DocumentRequiredFor?.includes("ssn") && !selectedExistingUser && formData["Administrator"]["socialSecurityNumber"] == "" ? "SSN did not match" : validateSSN("controlling_officer", businessResponse),
        address:
          account.DocumentRequiredFor?.includes("address") &&
          "Address did not match",
        dateOfBirth:
          account.DocumentRequiredFor?.includes("birthdate") ?
            "Birthdate did not match" : !selectedExistingUser && !businessResponse?.IsControllingOfficerIsAdmin && formData["Controlling Officer"]["dateOfBirth"] === "" && "Date of Birth is required",
        zipCode: account.DocumentRequiredFor?.includes("address") && true,
        city: account.DocumentRequiredFor?.includes("address") && true,
        state: account.DocumentRequiredFor?.includes("address") && true,
      };
      setKycInvestorError((prevState) => ({
        ...prevState,
        "Controlling Officer": errorData,
      }));

    }
    // Check for Beneficial Owner
    else if (account.BusinessUserType === "beneficial_owner") {

      const errordataTemp = [];
      // Add new Beneficial Owner data only if the investorId is not 0 and it doesn't already exist
      if (account?.InvestorId !== 0) {
        const errorData = {
          ...errors,
          lastName:
            account.DocumentRequiredFor?.includes("full_name") &&
            "OFAC sanctions match",
          email:
            account.DocumentRequiredFor?.includes("email") && "Email risk",
          phone:
            account.DocumentRequiredFor?.includes("phone") && "Phone risk",
          socialSecurityNumber:
            account.DocumentRequiredFor?.includes("ssn") && formData["Administrator"]["socialSecurityNumber"] == "" ? "SSN did not match" : validateSSN("beneficial_owner", businessResponse),
          address:
            account.DocumentRequiredFor?.includes("address") &&
            "Address did not match",
          dateOfBirth:
            account.DocumentRequiredFor?.includes("birthdate") ?
              "Birthdate did not match" : businessResponse?.IsBeneficialOwnerIsAdmin
                ? ""
                : businessResponse?.IsBeneficialOwnerIsControllingOfficer
                  ? ""
                  // formData["Controlling Officer"]["dateOfBirth"] === "" && "Date of Birth is required"
                  : !businessResponse?.IsBeneficialOwnerIsAdmin && !businessResponse?.IsBeneficialOwnerIsControllingOfficer && formData["Beneficial Owner"][0]["dateOfBirth"] === "" && "Date of Birth is required",
          zipCode: account.DocumentRequiredFor?.includes("address") && true,
          city: account.DocumentRequiredFor?.includes("address") && true,
          state: account.DocumentRequiredFor?.includes("address") && true,
          percentOwnership:
            formData["Beneficial Owner"][0]["percentOwnership"] === "" &&
            `Ownership percentage must be ${benificialPercentage === 100 ? '100' : 'between 50 and 100'}`,
        };
        errordataTemp.push(errorData);
        setKycInvestorError((prevState) => ({
          ...prevState,
          "Beneficial Owner": errordataTemp,
        }));
      }
    }
  }
  const checkIfFormIsValid = (updateData) => {
    const currentStepName = steps[currentStep];
    if (
      currentStepName === "Beneficial Owner" && (!loginInvestorId || (loginInvestorId && !isPurchaseProfile))
    ) {
      // If all owners are blank, consider the form valid
      const stepData = updateData[currentStepName];
      if (Array.isArray(stepData)) {
        const allOwnersBlank = stepData.every((entry, idx) => {
          const values = Object.values(entry);
          const isBlank = values.every(val => val === "" || val == null);
          return isBlank;
        });
        if (allOwnersBlank) {
          return true;
        }
      }
    }
    if (
      currentStepName === "Beneficial Owner" && loginInvestorId && isPurchaseProfile
    ) {
      // If all owners are blank, consider the form valid
      const stepData = updateData[currentStepName];
      if (Array.isArray(stepData)) {
        const allOwnersBlank = stepData.every(entry =>
          Object.values(entry).every(val => val === "" || val == null)
        );
        if (allOwnersBlank) {
          return true;
        }
      }
    }
    const currentErrors = kycInvestorError[currentStepName];
    const hasErrors = Array.isArray(currentErrors)
      ? currentErrors.some(err =>
        // err is an object; check if any key value is truthy (error message)
        Object.values(err || {}).some(val => Boolean(val))
      )
      : typeof currentErrors === 'object' && currentErrors !== null
        ? Object.values(currentErrors).some(val => {
          if (Array.isArray(val)) {
            // val is an array, e.g. Beneficial Owner
            return val.some(item => {
              // Check if object is NOT empty and has any truthy values
              const hasKeys = Object.keys(item || {})?.length > 0;
              return hasKeys && Object.values(item).some(v => Boolean(v));
            });
          }
          return Boolean(val); // val is boolean or error string
        })
        : false;

    if (hasErrors) {
      return false;
    }
    const stepData = updateData[currentStepName];
    const fields = formFieldsByStep[currentStepName];
    if (Array.isArray(stepData)) {
      // If all owners are blank, already handled above
      const isOwnerValid = stepData.every((entry) =>
        fields.every(({ name }) => {
          if (name === "documentCountry" || name === "documentState") {
            // Only require at least one of the two fields to be filled
            return (
              (entry["documentCountry"] && entry["documentCountry"] !== "") ||
              (entry["documentState"] && entry["documentState"] !== "")
            );
          }
          return entry[name] !== "" && entry[name] != null;
        })
      );
      // Additional logic for investor context
      if (
        loginInvestorId &&
        !isPurchaseProfile &&
        currentStepName === "Beneficial Owner"
      ) {
        return isOwnerValid;
      }
      return isOwnerValid;
    } else {
      return fields.every(({ name }) => {
        if (name === "documentCountry" || name === "documentState") {
          // Only require at least one of the two
          return (
            (stepData["documentCountry"] && stepData["documentCountry"] !== "") ||
            (stepData["documentState"] && stepData["documentState"] !== "")
          );
        }
        return stepData[name] !== "" && stepData[name] != null;
      });
    }
  };

  useEffect(() => {
    const isValidData = checkIfFormIsValid(formData)
    setIsFormValid(isValidData);
  }, [formData, currentStep, steps, formFieldsByStep, loginInvestorId,
    isPurchaseProfile, selectedExistingUser, selectedExistingBeneficialOwner]);


  useEffect(() => {
    setIsFormValid(checkIfFormIsValid(formData));
  }, [errors, formData, currentStep, steps, formFieldsByStep, loginInvestorId,
    isPurchaseProfile, selectedExistingUser, selectedExistingBeneficialOwner]);


  const validateField = (value, fieldName, benificialPercentage) => {
    const step = steps[currentStep];
    if (fieldName === "zipCode") {
      const zipPattern = /^\d{5}(-\d{4})?$/;
      if (!zipPattern.test(value) && value?.length > 0) {
        return "ZIP code must be in format 00000 or 00000-0000";
      }
    }
    else if (fieldName === "phone") {
      const digits = (value || "").replace(/\D/g, "");
      if (digits.length !== 10 && value?.length > 0) {
        return "Phone number must be 10 digits";
      }
    } else if (fieldName === "dateOfBirth") {
      if (value === "Invalid date") {
        return "Invalid Date";

      }
    } else if (fieldName === "email") {
      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value) && value?.length > 0) {
        return "Invalid email address";
      }
    } else if (fieldName === "city") {
      if (!value?.trim()?.length > 0) {
        return "City is required.";
      }
    }
    else if (fieldName === "firstName") {
      if (!value?.trim()?.length > 0) {
        return "First Name is required.";
      }
    }
    else if (fieldName === "lastName") {
      if (!value?.trim()?.length > 0) {
        return "Last Name is required.";
      }
    }
    else if (fieldName === "address") {
      if (!value?.trim()?.length > 0) {
        return "Address is required.";
      }
    }
    else if (fieldName === "documentId") {
      if (!value?.trim()?.length > 0) {
        return "Document Id is required.";
      }
      let documentType;
      if (step === "Beneficial Owner") {
        documentType = formData?.[step]?.[0]?.documentType;
      } else {
        documentType = formData?.[step]?.documentType;
      }
      const typeLabels = {
        id_passport: "Passport",
        id_passport_card: "Passport Card",
        doc_green_card: "Green Card",
        id_drivers_license: "Driver's License",
        id_drivers_permit: "Driver's Permit",
        id_state: "State ID",
      };
      const label = typeLabels[documentType] || "selected document type";
      let min = 0, max = 0;
      switch (documentType) {
        case "id_passport":
        case "id_passport_card":
          min = 6;
          max = 9;
          break;
        case "doc_green_card":
          min = 7;
          max = 9;
          break;
        case "id_drivers_license":
        case "id_drivers_permit":
        case "id_state":
          min = 4;
          max = 24;
          break;
        default:
          return "";
      }
      const trimmed = value.trim();
      if (trimmed.length < min || trimmed.length > max) {
        return `Document ID must be between ${min} and ${max} characters for ${label}`;
      }
    }
    return ""; // no error
  };

  const sanitizeFieldValue = (value, fieldName) => {
    const maxLengths = {
      socialSecurityNumber: 9,
      zipCode: 10,
      phone: 10,
    };
    if (fieldName === "phone") {
      return value.replace(/[A-Za-z]/g, "").replace(/[()\-\s]/g, "").slice(0, maxLengths.phone);
    } else if (fieldName === "documentId") {
      return value.replace(/\s/g, "");
    }
    else if (fieldName === "socialSecurityNumber") {
      return value
        .replace(/\D/g, "")
        .slice(0, maxLengths.socialSecurityNumber);
    } else if (fieldName === "zipCode") {
      const digits = value.replace(/\D/g, "").slice(0, 9); // max 9 digits
      if (digits.length <= 5) {
        return digits;
      }
      const firstPart = digits.slice(0, 5);
      const secondPart = digits.slice(5);
      return `${firstPart}-${secondPart}`;
    } else if (maxLengths[fieldName]) {
      return value.slice(0, maxLengths[fieldName]);
    } else if (fieldName === "city") {
      return value.replace(/[^a-zA-Z\s'-]/g, "")
    }
    return value;
  };

  function areDetailsUniqueMultiFields(entity1, entity2, customFieldLabels = {}) {
    const defaultFieldLabels = {
      socialSecurityNumber: "Social Security Number",
      // email: "Email",
      // phone: "Phone Number"
    };

    const fieldLabels = { ...defaultFieldLabels, ...customFieldLabels };
    const fields = Object.keys(fieldLabels);

    const duplicates = [];

    for (let field of fields) {
      const val1 = entity1?.[field] || "";
      const val2 = entity2?.[field] || "";
      if (val1 !== "" && val2 !== "" && val1 === val2) {
        duplicates.push({
          field,
          label: fieldLabels[field],
          value: val1,
        });
      }
    }

    return {
      valid: duplicates?.length === 0,
      duplicates,
    };
  }
  const handleResetErrors = (step) => {
    setKycInvestorError({
      ...kycInvestorError,
      [step]: step === "Beneficial Owner" ? [{}] : {}
      // Administrator: {},
      // "Controlling Officer": {},
      // "Beneficial Owner": [{}],
    })
    setErrors({})
  }

  const handleInputChange = (e, step, fieldName, ownerIndex = 0, cursorPos, inputRef) => {
    // Prevent inserting more digits than max allowed for phone, zipCode, and SSN
    const maxLengths = {
      phone: 10,
      zipCode: 9,
      socialSecurityNumber: 9,
    };
    if (["phone", "zipCode", "socialSecurityNumber"].includes(fieldName)) {
      // Get the raw digits from the current value in state
      let currentDigits = "";
      if (step === "Beneficial Owner") {
        currentDigits = (formData[step][ownerIndex]?.[fieldName] || "").replace(/\D/g, "");
      } else {
        currentDigits = (formData[step]?.[fieldName] || "").replace(/\D/g, "");
      }
      // Get the raw digits from the new value
      const rawValue = e?.target?.value || "";
      const newDigits = (rawValue || "").replace(/\D/g, "");
      // If at max length and trying to insert (not replace), ignore the input
      if (
        currentDigits.length === maxLengths[fieldName] &&
        newDigits.length > maxLengths[fieldName]
      ) {
        // Allow replacing a digit if a selection is made
        if (e.target.selectionStart === e.target.selectionEnd) {
          // No selection, so it's an insert, block it
          return;
        }
      }
    }
    const { value: rawValue } = e?.target || {};
    const sanitizedValue = sanitizeFieldValue(rawValue, fieldName);
    const isDateField = fieldName === "dateOfBirth";
    const formattedDate = isDateField
      ? moment(e?.$d).format("YYYY-MM-DD")
      : undefined;

    const prevValueKey = `${step}_${fieldName}_${ownerIndex}`;
    const prevValue = prevValuesRef.current[prevValueKey] || '';
    prevValuesRef.current[prevValueKey] = rawValue;

    setFormData((prevData) => {
      const updatedData = { ...prevData };
      if (step === "Beneficial Owner") {
        const updatedOwners = JSON.parse(JSON.stringify(prevData[step] || [])); // Deep clone
        const currentOwner = updatedOwners[ownerIndex] || {};

        // Mutually exclusive logic for documentCountry/documentState
        if (fieldName === "documentCountry") {
          currentOwner["documentCountry"] = sanitizedValue;
          currentOwner["documentState"] = "";
        } else if (fieldName === "documentState") {
          currentOwner["documentState"] = sanitizedValue;
          currentOwner["documentCountry"] = "";
        } else if (fieldName === "documentType") {
          currentOwner[fieldName] = sanitizedValue;
          currentOwner["documentState"] = "";
          currentOwner["documentCountry"] = "";
        } else {
          currentOwner[fieldName] = isDateField ? formattedDate : sanitizedValue;
        }

        updatedOwners[ownerIndex] = currentOwner;
        updatedData[step] = updatedOwners;

        validateFormData(updatedData, step, fieldName);

        // Restore cursor for phone/zipCode/ssn
        if ((fieldName === "phone" || fieldName === "zipCode" || fieldName === "socialSecurityNumber") && inputRef && cursorPos != null) {
          setTimeout(() => {
            try {
              const el = inputRef.current;
              if (el) {
                let formatted = el.value;
                // Special case: if the previous value was longer and the new value is shorter by 1, and the cursor is at position 0, set cursor to 0
                if (
                  prevValue &&
                  prevValue.length > rawValue.length &&
                  cursorPos === 0
                ) {
                  el.setSelectionRange(0, 0);
                } else {
                  // 1. Count digits before the cursor in the raw (unformatted) value
                  let digitsBeforeCursor = 0;
                  for (let i = 0; i < cursorPos; i++) {
                    if (rawValue[i] && /\d/.test(rawValue[i])) digitsBeforeCursor++;
                  }
                  // 2. Find the position in the formatted value after the same number of digits
                  let digitCount = 0;
                  let newCursorPos = 0;
                  for (; newCursorPos < formatted.length; newCursorPos++) {
                    if (/\d/.test(formatted[newCursorPos])) digitCount++;
                    if (digitCount === digitsBeforeCursor) {
                      newCursorPos++;
                      break;
                    }
                  }
                  // If deleting at the end, keep at end
                  if (cursorPos === rawValue.length) {
                    el.setSelectionRange(formatted.length, formatted.length);
                  } else {
                    el.setSelectionRange(newCursorPos, newCursorPos);
                  }
                }
              }
            } catch { }
          }, 0);
        }

        return { ...prevData, [step]: updatedOwners };
      } else if (step === "Controlling Officer" || step === "Administrator") {
        // Mutually exclusive logic for documentCountry/documentState
        if (fieldName === "documentCountry") {
          updatedData[step] = {
            ...updatedData[step],
            documentCountry: sanitizedValue,
            documentState: "",
          };
        } else if (fieldName === "documentState") {
          updatedData[step] = {
            ...updatedData[step],
            documentState: sanitizedValue,
            documentCountry: "",
          };
        } else if (fieldName === "documentType") {
          updatedData[step] = {
            ...updatedData[step],
            [fieldName]: sanitizedValue,
            documentState: "",
            documentCountry: ""
          };
        }

        else {
          updatedData[step] = {
            ...updatedData[step],
            [fieldName]: isDateField ? formattedDate : sanitizedValue,
          };
        }

        validateFormData(updatedData, step, fieldName);

        // Restore cursor for phone/zipCode/ssn
        if ((fieldName === "phone" || fieldName === "zipCode" || fieldName === "socialSecurityNumber") && inputRef && cursorPos != null) {
          setTimeout(() => {
            try {
              const el = inputRef.current;
              if (el) {
                let formatted = el.value;
                // Special case: if the previous value was longer and the new value is shorter by 1, and the cursor is at position 0, set cursor to 0
                if (
                  prevValue &&
                  prevValue.length > rawValue.length &&
                  cursorPos === 0
                ) {
                  el.setSelectionRange(0, 0);
                } else {
                  // 1. Count digits before the cursor in the raw (unformatted) value
                  let digitsBeforeCursor = 0;
                  for (let i = 0; i < cursorPos; i++) {
                    if (rawValue[i] && /\d/.test(rawValue[i])) digitsBeforeCursor++;
                  }
                  // 2. Find the position in the formatted value after the same number of digits
                  let digitCount = 0;
                  let newCursorPos = 0;
                  for (; newCursorPos < formatted.length; newCursorPos++) {
                    if (/\d/.test(formatted[newCursorPos])) digitCount++;
                    if (digitCount === digitsBeforeCursor) {
                      newCursorPos++;
                      break;
                    }
                  }
                  // If deleting at the end, keep at end
                  if (cursorPos === rawValue.length) {
                    el.setSelectionRange(formatted.length, formatted.length);
                  } else {
                    el.setSelectionRange(newCursorPos, newCursorPos);
                  }
                }
              }
            } catch { }
          }, 0);
        }

        // Check for duplicate fields between Administrator and Controlling Officer
        if (step === "Controlling Officer" && ((fieldName === "socialSecurityNumber" && sanitizedValue?.length === 9) || fieldName === "email" || fieldName === "phone")) {
          let validation;
          if (radioControllling) {
            validation = { valid: true }
          } else {
            const rolesToCheck = ["Beneficial Owner", "Administrator"];

            rolesToCheck.forEach((role) => {

              const compareData = role === "Beneficial Owner"
                ? formData[role][0] // handle array if Beneficial Owner is an array
                : formData[role];
              if ((role === "Beneficial Owner" && isThisBenificialOwnerCo === "no" || role === "Administrator")) {
                validation = areDetailsUniqueMultiFields(
                  updatedData["Controlling Officer"],
                  compareData
                );
                if (!validation.valid) {
                  if (
                    (fieldName === "socialSecurityNumber" && !kycInvestorError["Beneficial Owner"][0]?.socialSecurityNumber) ||
                    (fieldName === "email" && !kycInvestorError["Beneficial Owner"][0]?.email)) {
                    validation.duplicates.forEach((dup) => {
                      setKycInvestorError((prev) => ({
                        ...prev,
                        [step]: {
                          ...prev[step],
                          [dup.field]: role === "Administrator" ? `${role} and Controlling Officer cannot have the same ${dup.label}` : `Controlling Officer and ${role} cannot have the same ${dup.label}`
                        }
                      }))
                    });
                  }
                } else {

                  if (role === "Administrator") {
                    if (fieldName === "email" || formData[role][fieldName]?.length === 9) {
                      setKycInvestorError((prev) => {
                        const updated = { ...prev };
                        if (updated[role]) {
                          const updatedRole = { ...updated[role] };
                          delete updatedRole[fieldName]; // ❌ Delete the key instead of clearing it
                          updated[role] = updatedRole;
                        }
                        return updated;
                      });
                    }
                  } else {
                    if (fieldName === "email" || formData[role][fieldName]?.length === 9) {
                      setKycInvestorError((prev) => {
                        const updated = { ...prev };
                        if (updated[role]?.[0]) {
                          const updatedRole = { ...updated[role][0] };
                          delete updatedRole[fieldName]; // ❌ Delete the key
                          updated[role] = [updatedRole];
                        }
                        return updated;
                      });
                    }
                  }

                }
              }
            });
          }
        } else if (step === "Administrator" && ((fieldName === "socialSecurityNumber" && sanitizedValue?.length === 9) || fieldName === "phone")) {
          const rolesToCheck = ["Controlling Officer", "Beneficial Owner"];
          rolesToCheck.forEach((role) => {
            const isBeneficialOwner = role === "Beneficial Owner";
            const isControllingOfficer = role === "Controlling Officer";

            const compareData = isBeneficialOwner
              ? formData[role][0] // handle array if Beneficial Owner is an array
              : formData[role];

            const shouldValidate =
              (isBeneficialOwner && isThisBenificialOwner === "no") ||
              (isControllingOfficer && !radioControllling);

            if (!shouldValidate) return;

            const dup = areDetailsUnique(updatedData["Administrator"], compareData);
            const hasNoSSNError =
              (isBeneficialOwner && !kycInvestorError["Beneficial Owner"]?.[0]?.socialSecurityNumber && !kycInvestorError["Beneficial Owner"]?.[0]?.phone) ||
              (isControllingOfficer && !kycInvestorError["Controlling Officer"]?.socialSecurityNumber && !kycInvestorError["Controlling Officer"]?.phone);
            if (!dup.valid) {
              if (hasNoSSNError) {
                setKycInvestorError((prev) => ({
                  ...prev,
                  [step]: {
                    ...prev[step],
                    [dup.field]: `Administrator and ${role} cannot have the same ${dup.label}`
                  }
                }));
              }
            } else {
              if (role === "Controlling Officer") {
                if (formData[role][fieldName]?.length === 9) {
                  setKycInvestorError((prev) => {
                    const updated = { ...prev };
                    if (updated[role]) {
                      const updatedRole = { ...updated[role] };
                      delete updatedRole[fieldName]; // ❌ Delete the key instead of clearing it
                      updated[role] = updatedRole;
                    }
                    return updated;
                  });
                }
              } else {
                if (formData[role][0][fieldName]?.length === 9) {
                  setKycInvestorError((prev) => {
                    const updated = { ...prev };
                    if (updated[role]?.[0]) {
                      const updatedRole = { ...updated[role][0] };
                      delete updatedRole[fieldName]; // ❌ Delete the key
                      updated[role] = [updatedRole];
                    }
                    return updated;
                  });
                }
              }
            }
          });
        }

      } else {
        // ...existing logic for other steps...
        updatedData[step] = {
          ...updatedData[step],
          [fieldName]: isDateField ? formattedDate : sanitizedValue,
        };

        validateFormData(updatedData, step, fieldName);
      }

      return updatedData;
    });

    const error = validateField(sanitizedValue, fieldName, benificialPercentage);
  };


  const handleAddOwner = () => {
    setFormData((prevData) => {
      const newData = {
        ...prevData,
        "Beneficial Owner": [
          ...prevData["Beneficial Owner"],
          {
            firstName: "",
            lastName: "",
            address: "",
            city: "",
            state: "",
            zipCode: "",
            dateOfBirth: "",
            socialSecurityNumber: "",
            email: "",
            phone: "",
            percentOwnership: "",
            documentId: "",
            documentType: "",
          },
        ],
      };
      return newData;
    });
    validateFormData(formData, "Beneficial Owner"); // Validate after adding owner
  };

  const handleRemoveOwner = (ownerIndex) => {
    setFormData((prevData) => {
      const updatedOwners = prevData["Beneficial Owner"].filter(
        (_, index) => index !== ownerIndex
      );
      return { ...prevData, "Beneficial Owner": updatedOwners };
    });
  };

  function areDetailsUnique(admin, officer) {
    const fieldLabels = {
      socialSecurityNumber: "Social Security Number",
      // email: "Email",
      // phone: "Phone"
    };

    const fields = Object.keys(fieldLabels);

    for (let field of fields) {
      if (
        (admin?.[field] || "") !== "" &&
        (officer?.[field] || "") !== "" &&
        (admin?.[field] || "") === (officer?.[field] || "")
      ) {

        return {
          valid: false,
          field,
          label: fieldLabels[field],
          value: admin[field],
        };
      }
    }
    return { valid: true };
  }

  const handleNextStep = async () => {
    const SignupEmail = instance.getActiveAccount()?.idTokenClaims?.email || sessionStorage.getItem('impersonateEmail') || userData?.email;
    const currentStepName = steps[currentStep]; // Get the current step based on the dynamic steps array
    let validationErrors: ValidationErrors = {}
    if (loginInvestorId && !isPurchaseProfile || id && isPurchaseProfile) {
    } else {
      validationErrors = validateFormData(formData, currentStepName);
    }

    setShift(false);
    // Step for Beneficial Owner: Validate ownership percentage
    if (currentStepName === "Beneficial Owner") {
      const totalOwnership = formData["Beneficial Owner"].reduce(
        (total: number, owner: any) =>
          total + parseFloat(owner.percentOwnership || "0"),
        0
      );
      if (totalOwnership > 100) {
        validationErrors["totalOwnership"] =
          "Total ownership percentage cannot exceed 100%.";
      }

      // Check for duplicates between Beneficial Owners and Administrator/Controlling Officer
      for (let i = 0; i < formData["Beneficial Owner"]?.length; i++) {
        const beneficialOwner = formData["Beneficial Owner"][i];

        // Check against Administrator
        if (isThisBenificialOwner === "yes" || isThisBenificialOwnerCo === "yes") {

        } else {
          const adminValidation = areDetailsUnique(
            formData["Administrator"],
            beneficialOwner
          );
          if (!adminValidation.valid) {
            validationErrors[`owner_${i}_${adminValidation.field}`] =
              `Administrator and Beneficial Owner #${i + 1} cannot have the same ${adminValidation.label}`;
          }

          // Check against Controlling Officer
          const officerValidation = areDetailsUnique(
            formData["Controlling Officer"],
            beneficialOwner
          );
          if (!officerValidation.valid) {
            validationErrors[`owner_${i}_${officerValidation.field}`] =
              `Controlling Officer and Beneficial Owner #${i + 1} cannot have the same ${officerValidation.label}`;
          }
          for (let j = i + 1; j < formData["Beneficial Owner"]?.length; j++) {
            const otherBeneficialOwner = formData["Beneficial Owner"][j];
            const beneficialValidation = areDetailsUnique(
              beneficialOwner,
              otherBeneficialOwner
            );
            if (!beneficialValidation.valid) {
              validationErrors[`beneficial_${i}_${beneficialValidation.field}`] =
                `Beneficial Owner #${i + 1} and Beneficial Owner #${j + 1} cannot have the same ${beneficialValidation.label}`;
            }
          }
        }
      }
    }
    // Proceed if no validation errors exist
    if (Object.keys(validationErrors)?.length === 0) {
      try {
        let emailAvailable = true;
        if (currentStepName === "Administrator") {
          if ((!loginInvestorId || id) && radioControllling) {
            setFormData((prevState) => {
              return {
                ...prevState,
                "Controlling Officer": {
                  ...prevState["Controlling Officer"],
                  ...prevState.Administrator,
                  investorId: parseInt(formData["Controlling Officer"].investorId),
                },
              }
            });
          }
          if (
            IsControllingOfficerIsAdmin &&
            loginInvestorId &&
            !isPurchaseProfile
          ) {
            setFormData((prevState) => {
              return {
                ...prevState,
                "Controlling Officer": {
                  ...prevState["Controlling Officer"],
                  ...prevState.Administrator,
                  investorId: parseInt(formData["Controlling Officer"].investorId),
                },
              }
            });
          }
        } else if (currentStepName === "Controlling Officer") {
          const officerEmail = formData["Controlling Officer"].email;
          if (isThisBenificialOwner === "yes") {
            setFormData((prevState) => {

              return {
                ...prevState,
                "Beneficial Owner": [{
                  ...prevState.Administrator,
                  percentOwnership: prevState["Beneficial Owner"][0].percentOwnership,
                  investorId: parseInt(formData["Beneficial Owner"][0].investorId),
                }],
              }
            });
          }
          if (isThisBenificialOwnerCo === "yes") {
            setFormData((prevState) => {
              return {
                ...prevState,
                "Beneficial Owner": [{
                  ...prevState["Controlling Officer"],
                  percentOwnership: prevState["Beneficial Owner"][0].percentOwnership,
                  investorId: parseInt(formData["Beneficial Owner"][0]?.investorId),
                }],
              }
            });
          }
        } else if (currentStepName === "Beneficial Owner") {
          dispatch(addbenificialsOfficers({
            data: formData["Beneficial Owner"],
            isThisBenificialOwnerCo,
            isThisBenificialOwner
          }));
          dispatch(addSelectedExistingBeneficialOwner(selectedExistingBeneficialOwner));
          // For Beneficial Owner, iterate through the owners and check email
          const BenificialOwner = formData[currentStepName].map(
            (ele: { email: string }) => ele.email);
        }

        // Handle form submission logic for different steps
        if (currentStepName === "Administrator") {
          dispatch(addAdministration(formData["Administrator"]));

          const UUIDAdmin = generateGUID();
          const adminDataValue = normalizeUserData(formData["Administrator"], SignupEmail
          );
          setApiData((prevState) => ({
            ...prevState, adminData: {
              ...adminDataValue,
              userId: loginUserId,
              parentInvestorId: loginInvestorId ? parseInt(loginInvestorId) : undefined,
              kybRequestModel: {
                reference: UUIDAdmin,
                role: "administrator",
                details: "Admin",
                action: "link_business",
              },
            },
          }));
          moveToNextStep(); // Move to the next step
        } else if (currentStepName === "Controlling Officer") {
          dispatch(addcontrollingOfficer({ data: { ...formData["Controlling Officer"], selectedExistingUser }, isChecked: radioControllling }));
          dispatch(addSelectedExistingUser(selectedExistingUser));
          if (
            IsControllingOfficerIsAdmin &&
            loginInvestorId &&
            !isPurchaseProfile
          ) {
            setFormData((prevState) => {
              return {
                ...prevState,
                "Controlling Officer": {
                  ...prevState.Administrator,
                  investorId: parseInt(formData["Controlling Officer"].investorId),
                },
              }
            });
          }
          const UUIDCO = generateGUID();
          const officerDataValue = normalizeUserData(formData["Controlling Officer"], SignupEmail);
          const controllingOfficerData = {
            ...officerDataValue,
            userId: loginUserId,
            parentInvestorId: loginInvestorId ? parseInt(loginInvestorId) : undefined,
            kybRequestModel: {
              reference: UUIDCO,
              role: "controlling_officer",
              details: "CEO",
              action: "link_business",
            },
          };
          let adminApiData
          if (isPurchaseProfile) {
            const adminDataValue = normalizeUserData(formData["Administrator"], SignupEmail
            );
            const UUIDAdmin = generateGUID();
            dispatch(addAdministration(formData["Administrator"]));
            adminApiData = {
              ...adminDataValue,
              userId: loginUserId,
              parentInvestorId: loginInvestorId ? parseInt(loginInvestorId) : undefined,
              kybRequestModel: {
                reference: UUIDAdmin,
                role: "administrator",
                details: "Admin",
                action: "link_business",

              },
            }
            setApiData((prevState) => ({
              ...prevState, adminData: adminApiData,
              controllingOfficer: controllingOfficerData
            }));
          }
          else {
            await setApiData((prevState) => ({
              ...prevState, controllingOfficer: controllingOfficerData,
            }));
          }

          if (!isBenificial) {
            if (isPurchaseProfile) {
              // if (id) {
              //   setDialogOpen(true)
              // } else {
              setOpenLoader(true)
              // }
            } else {
              setOpenLoader(true);
            }

            setTimeout(async () => {
              const payload = {
                ...bussinessUserdata,
                existingInvestorId:0,
                isControllingOfficerIsAdmin: radioControllling,
                isBeneficialOwnerIsControllingOfficer:
                  isThisBenificialOwnerCo === "yes" ? true : false,
                isBeneficialOwnerIsAdmin:
                  isThisBenificialOwner === "yes" ? true : false,
                BusinessCategoriesId: bussinessUserdata.subCategory,
                bussinessRegistrationRequestModels: [
                  adminApiData || apiData.adminData,
                  controllingOfficerData || apiData.controllingOfficer,
                ],
              };
              try {
                const kybReponse = await dispatch(kybRegisterAPi(payload)).unwrap();
                const pollingInterval = setTimeout(async () => {
                  if (openErrorModel) return
                  try {
                    const { response, investorId } = await dispatch(getRegisterdInvestors(isPurchaseProfile ? payload?.Email : SignupEmail)).unwrap();
                    dispatch(setLoginUserdetails(response))

                    let purchaseProfileId;
                    // const accounts
                    let isSilaUnregistered
                    if (payload.Email === SignupEmail) {
                      let lastPurchaseProfile;
                      if (id) {
                        const filteredPurchaseProfile = response.PurchaseProfile.filter((ele) => ele.InvestorId === Number(id));
                        lastPurchaseProfile = filteredPurchaseProfile[0];
                      } else {
                        // If no id, take the last profile from the array
                        lastPurchaseProfile = response?.PurchaseProfile[response?.PurchaseProfile?.length - 1];
                      }
                      purchaseProfileId = kybReponse[0]?.body?.investorId
                      isSilaUnregistered = !lastPurchaseProfile?.IsSilaRegistered ||
                        (Array.isArray(lastPurchaseProfile?.BusinessChildAccounts) && lastPurchaseProfile?.BusinessChildAccounts.some(acc => !acc.IsSilaRegistered));
                    }
                    else {
                      purchaseProfileId = investorId
                      isSilaUnregistered = !response.IsSilaRegistered ||
                        (Array.isArray(response.BusinessAccounts) && response.BusinessAccounts.some(acc => !acc.IsSilaRegistered));
                    }
                    // Check if main account or any business account has IsSilaRegistered === false
                    if (isSilaUnregistered) {
                      // const kycDetails = await dispatch(getKycDetails(investorId)).unwrap();
                      if (isPurchaseProfile) {
                        const { response, investorId } = await dispatch(getRegisterdInvestors(SignupEmail)).unwrap()
                        dispatch(setLoginUserdetails(response))
                      }
                      setOpenLoader(false)
                      setOpenErrorModel(true)
                      setRegInvestorId(isPurchaseProfile ? id ? id : purchaseProfileId : investorId)
                    } else {
                      dispatch(initialResetState());
                      if (isPurchaseProfile) {
                        const { response, investorId } = await dispatch(getRegisterdInvestors(SignupEmail)).unwrap()
                        dispatch(setLoginUserdetails(response))
                        setDialogOpen(true)
                      } else {
                        navigate(
                          "/kyc-kyb/identity-verification/business/inprogress-validate"
                        );
                      }
                    }
                    clearTimeout(pollingInterval)
                  } catch (error) {
                    console.error("Error polling getRegisterdInvestors:", error);
                  }
                }, 5000);

              } catch (error) {
                console.error("Error in kybRegisterAPi:", error);
              }
            }, 500);
          } else {
            moveToNextStep();
          }
        } else if (currentStepName === "Beneficial Owner") {
          dispatch(addbenificialsOfficers({
            data: formData["Beneficial Owner"],
            isThisBenificialOwnerCo,
            isThisBenificialOwner
          }));
          dispatch(addSelectedExistingBeneficialOwner(selectedExistingBeneficialOwner));
          // For Beneficial Owner, iterate through the owners and check email
          const BenificialOwner = formData[currentStepName].map(
            (ele: { email: string }) => ele.email);

          const allBeneficialOwners = formData["Beneficial Owner"];
          const benificialOfficerData = allBeneficialOwners.map((ownerData) => {
            const benificialdata = normalizeUserData(ownerData, SignupEmail);
            const benificalOffiers = {
              ...benificialdata,
              userId: loginUserId,
              parentInvestorId: loginInvestorId ? parseInt(loginInvestorId) : undefined,
              kybRequestModel: {
                reference: generateGUID(),
                role: "beneficial_owner",
                details: "BO",
                action: "link_business",
                ownership_stake: benificialPercentage === 100 ? `${benificialPercentage}` : ownerData.percentOwnership,
              },
            };
            return benificalOffiers;
          });

          await setApiData((prevState) => ({
            ...prevState,
            benificialsOfficer: benificialOfficerData,
          }));

          if (isPurchaseProfile) {
            // if (id) {
            //   setDialogOpen(true)
            // } else {
            setOpenLoader(true)
            // }
          } else {
            setOpenLoader(true);
          }

          setTimeout(async () => {
            const payload = {
              ...bussinessUserdata,
              existingInvestorId:0,
              isControllingOfficerIsAdmin: radioControllling,
              isBeneficialOwnerIsControllingOfficer:
                isThisBenificialOwnerCo === "yes" ? true : false,
              isBeneficialOwnerIsAdmin:
                isThisBenificialOwner === "yes" ? true : false,
              BusinessCategoriesId: bussinessUserdata.subCategory,
              bussinessRegistrationRequestModels: [
                apiData.adminData,
                apiData.controllingOfficer,
                ...benificialOfficerData,
              ],
            };

            try {
              const kybReponse = await dispatch(kybRegisterAPi(payload)).unwrap();

              const pollingInterval = setTimeout(async () => {
                if (openErrorModel) return
                try {
                  const { response, investorId } = await dispatch(getRegisterdInvestors(isPurchaseProfile ? payload?.Email : SignupEmail)).unwrap();
                  dispatch(setLoginUserdetails(response))
                  let purchaseProfileId;
                  // const accounts
                  let isSilaUnregistered
                  if (isPurchaseProfile && payload.Email === SignupEmail) {
                    let lastPurchaseProfile;
                    if (id) {
                      const filteredPurchaseProfile = response.PurchaseProfile.filter((ele) => ele.InvestorId === Number(id));
                      lastPurchaseProfile = filteredPurchaseProfile[0];
                    } else {
                      // If no id, take the last profile from the array
                      lastPurchaseProfile = response.PurchaseProfile[response.PurchaseProfile.length - 1];
                    }
                    purchaseProfileId = kybReponse[0]?.body?.investorId
                    isSilaUnregistered = !lastPurchaseProfile?.IsSilaRegistered ||
                      (Array.isArray(lastPurchaseProfile?.BusinessChildAccounts) && lastPurchaseProfile?.BusinessChildAccounts.some(acc => !acc.IsSilaRegistered));
                  }
                  else {
                    purchaseProfileId = investorId
                    isSilaUnregistered = !response.IsSilaRegistered ||
                      (Array.isArray(response.BusinessAccounts) && response.BusinessAccounts.some(acc => !acc.IsSilaRegistered));
                  }
                  // Check if main account or any business account has IsSilaRegistered === false
                  if (isSilaUnregistered) {
                    // const kycDetails = await dispatch(getKycDetails(investorId)).unwrap();
                    isPurchaseProfile && await dispatch(getRegisterdInvestors(SignupEmail)).unwrap()
                    setOpenLoader(false)
                    setOpenErrorModel(true)
                    // setRegInvestorId(investorId)
                    setRegInvestorId(isPurchaseProfile ? id ? id : purchaseProfileId : investorId)

                  } else {

                    dispatch(initialResetState());
                    if (isPurchaseProfile) {
                      await dispatch(getRegisterdInvestors(SignupEmail)).unwrap()
                      setDialogOpen(true)
                    } else {
                      navigate(
                        "/kyc-kyb/identity-verification/business/inprogress-validate"
                      );
                    }
                  }
                  clearTimeout(pollingInterval)
                } catch (error) {
                  console.error("Error polling getRegisterdInvestors:", error);
                }
              }, 5000);

              // }


            } catch (error) {
              console.error("Error in kybRegisterAPi:", error);
            }
          }, 500); // Delay the API call by 2000 ms (2 seconds)
        }
      } catch (error) {
        console.error("Error in handleNextStep:", error);
      }
    }
  };
  // Helper function to move to the next step in the process
  const moveToNextStep = () => {
    if (currentStep < steps?.length - 1) {
      setCurrentStep((prevStep) => prevStep + 1); // Increment the step counter to move to the next step
      setShift(false);
    }
  };


  const handlePreviousStep = async () => {
    setErrors({})
    const currentStepName = steps[currentStep];
    if (currentStepName === "Controlling Officer") {
      dispatch(addcontrollingOfficer({ data: { ...formData["Controlling Officer"], selectedExistingUser }, isChecked: radioControllling }));
      dispatch(addbenificialsOfficers({
        data: formData["Beneficial Owner"],
        isThisBenificialOwnerCo,
        isThisBenificialOwner
      }));
      navigate(-1); // Navigate to the previous page or go back in history      } else if (currentStepName === "Beneficial Owner") {

    } else if (currentStepName === "Beneficial Owner") {
      dispatch(addbenificialsOfficers({
        data: formData["Beneficial Owner"],
        isThisBenificialOwnerCo,
        isThisBenificialOwner
      }));
      dispatch(addSelectedExistingBeneficialOwner(selectedExistingBeneficialOwner));

      setCurrentStep((prevStep) => prevStep - 1);
    }


  };

  const handleNavigate = () => {
    dispatch(initialResetState());
    navigate("/purchaseprofile");
  };
  const handleChange = async(event: any) => {
    handleResetErrors(steps[currentStep])
    setRadioControlling(event.target.value === "yes" ? true : false);
    if (isPurchaseProfile && event.target.value == 'no') {
      setExistingUserLoading(true);
      await dispatch(getExistingUser({ investorId: updatedInvestorId, user_type: steps[currentStep] == "Controlling Officer" ? "controlling_officer" : steps[currentStep] == "Beneficial Owner" ? "beneficial_owner" : null }))
      .finally(() => setExistingUserLoading(false));
    }

    if (event.target.value === "yes") {
      setHideControllingOfficer(true);

      isThisBenificialOwnerCoState === "yes" && dispatch(addbenificialsOfficers({
        data: [{
          investorId: 0,
          firstName: "",
          lastName: "",
          address: "",
          city: "",
          state: "",
          zipCode: "",
          dateOfBirth: "",
          socialSecurityNumber: "",
          email: "",
          phone: "",
          percentOwnership: ""
        }], isThisBenificialOwnerCo: null
      }))
      setFormData((prevState) => {
        return {
          ...prevState,
          "Controlling Officer": {
            ...prevState.Administrator,
            investorId: (loginInvestorId && !isPurchaseProfile) ? parseInt(loginUserDetails?.BusinessAccounts[1]?.investorId) : 0,
          },
        }
      });
      setErrors({});
    } else {
      setHideControllingOfficer(false);
      setFormData((prevState) => ({
        ...prevState,
        "Controlling Officer": {
          investorId: 0,
          firstName: "",
          lastName: "",
          address: "",
          city: "",
          state: "",
          zipCode: "",
          dateOfBirth: "",
          socialSecurityNumber: "",
          email: "",
          phone: "",
        },
      }));
    }
  };

  
useEffect(() => {
  if (isPurchaseProfile) {
    setExistingUserLoading(true);
    (async () => {
      try {   
        await dispatch(getExistingUser({
          
          investorId: updatedInvestorId,
          user_type:
            steps[currentStep] === "Controlling Officer"
              ? "controlling_officer"
              : steps[currentStep] === "Beneficial Owner"
              ? "beneficial_owner"
              : null,
        }));
      } finally {
        setExistingUserLoading(false);
      }
    })();
  }
}, [steps[currentStep]]);


  const handleChangeIsThisBenificialOwner = (event: any) => {
    handleResetErrors(steps[currentStep])
    setIsThisBenificialOwner(event.target.value);
    setSelectError(prev => ({ ...prev, selectboisadmin: "" }));
    dispatch(addIsThisBenificialOwnerState(event.target.value))
    if (event.target.value === 'yes') {
      // Clear all errors when switching to yes
      setFormData((prevState) => ({
        ...prevState,
        'Beneficial Owner': [{
          ...prevState['Beneficial Owner'][0], // Only the first owner object
          ...prevState["Administrator"],
          investorId: (loginInvestorId && !isPurchaseProfile) ? parseInt(loginUserDetails?.BusinessAccounts[2]?.investorId) : 0,
          percentOwnership: benificialPercentage === 100 ? `${benificialPercentage}` : "", // Add the required percentOwnership field
        }]
      }));
      setIsThisBenificialOwnerCO(null)

      setKycInvestorError((prev) => ({
        ...prev,
        ["Beneficial Owner"]: [{
          ...prev["Beneficial Owner"][0],
          percentOwnership: benificialPercentage === 100 ? "" : 'Percent Ownership is required',
        }]
      }))
      setErrors((prev) => ({
        ...prev,
        [`owner_0_percentOwnership`]: benificialPercentage === 100 ? "" : "Percent Ownership is required"
      }));

    } else {
      // Clear all errors when switching to no
      setErrors({});

      dispatch(addbenificialsOfficers({
        data: [{
          investorId: 0,
          firstName: "",
          lastName: "",
          address: "",
          city: "",
          state: "",
          zipCode: "",
          dateOfBirth: "",
          socialSecurityNumber: "",
          email: "",
          phone: "",
          percentOwnership: ""
        }], isThisBenificialOwnerCo,
        isThisBenificialOwner: "no"
      }))
      // Reset Beneficial Owner data when user selects 'no'
      setFormData((prevState) => ({
        ...prevState,
        'Beneficial Owner': [{
          investorId: 0,
          firstName: "",
          lastName: "",
          address: "",
          city: "",
          state: "",
          zipCode: "",
          dateOfBirth: "",
          socialSecurityNumber: "",
          email: "",
          phone: "",
          percentOwnership: ""
        }]
      }));
    }
  };
  const handleChangeforCO = (event: any) => {
    handleResetErrors(steps[currentStep])
    setIsThisBenificialOwnerCO(event.target.value);
    setSelectError(prev => ({ ...prev, selectboisco: "" }));
    dispatch(addIsThisBenificialOwnerCoState(event.target.value))
    if (event.target.value === 'yes') {

      // Clear all errors when switching to yes
      setFormData((prevState) => ({
        ...prevState,
        'Beneficial Owner': [{
          ...prevState["Controlling Officer"],
          percentOwnership: benificialPercentage === 100 ? `${benificialPercentage}` : "", // Add the required percentOwnership field
          investorId: (loginInvestorId && !isPurchaseProfile) ? parseInt(loginUserDetails?.BusinessAccounts[2]?.investorId) : 0,
        }]
      }));
      setKycInvestorError((prev) => ({
        ...prev,
        ["Beneficial Owner"]: [{
          ...prev["Beneficial Owner"][0],
          percentOwnership: benificialPercentage === 100 ? "" : 'Percent Ownership of Business is required'
        }]
      }))
      setErrors((prev) => ({
        ...prev,
        [`owner_0_percentOwnership`]: benificialPercentage === 100 ? "" : "Percent Ownership of Business is required"
      }));

    } else {
      // Clear all errors when switching to no
      setErrors({});
      dispatch(addbenificialsOfficers({
        data: [{
          investorId: 0,
          firstName: "",
          lastName: "",
          address: "",
          city: "",
          state: "",
          zipCode: "",
          dateOfBirth: "",
          socialSecurityNumber: "",
          email: "",
          phone: "",
          percentOwnership: ""
        }], isThisBenificialOwnerCo: "no",
        isThisBenificialOwner
      }))
      // Reset Beneficial Owner data when user selects 'no'
      setFormData((prevState) => ({
        ...prevState,
        'Beneficial Owner': [{
          investorId: 0,
          firstName: "",
          lastName: "",
          address: "",
          city: "",
          state: "",
          zipCode: "",
          dateOfBirth: "",
          socialSecurityNumber: "",
          email: "",
          phone: "",
          percentOwnership: ""
        }]
      }));
    }
  };

  // useEffect(() => {
  // const step = steps[currentStep];
  // const stepData = formData?.[step];
  // if (!stepData) return;
  // const isBeneficialOwner = step === "Beneficial Owner";
  // const data = isBeneficialOwner ? stepData?.[0] : stepData;
  // const documentType = data?.documentType;
  // const documentId = data?.documentId;

  //   if (documentType?.length > 0 && documentId?.length > 0) {
  //   const errorMessage = validateField(documentId, "documentId");
  //   if(step=="Beneficial Owner"){
  //   setKycInvestorError((prev) => ({
  //         ...prev,
  //         [step]: [
  //           {
  //             ...(prev[step]?.[0] || {}),
  //             documentId: errorMessage,
  //           },
  //         ],
  //       }));
  //   }else{
  //     setKycInvestorError(prev => ({
  //       ...prev,
  //       [step]: {
  //         ...prev[step],
  //         documentId: errorMessage
  //       }
  //     }));
  //   }
  //   }
  //   }, [
  //   formData?.[steps[currentStep]]?.documentType,
  //   formData?.["Beneficial Owner"]?.[0]?.documentType,
  //   ]);
  useEffect(() => {
    if (
      responseData?.data &&
      userData?.purchaseProfile && id
    ) {
      userData.purchaseProfile.forEach((profile) => {
        profile.BusinessChildAccounts?.forEach((account) => {
          if (account.BusinessUserType === "controlling_officer") {
           
            const match = responseData.data.find(
              (item) =>
                item.userHandle && account.UserHandle && item.userHandle === account.UserHandle
            );
            if (match) {
              if (id && !account?.IsExisting) {
                setSelectedExistingUser('none')
              } else {
                setSelectedExistingUser(match.id || match.investorId || null);

              }
            }
          } else {
            setSelectedExistingUser('none')
          }
        });
      });
    }
  }, [responseData, userData]);

  useEffect(() => {
    if (
      responseData?.data &&
      userData?.purchaseProfile && id
    ) {
      userData.purchaseProfile.forEach((profile) => {
        profile.BusinessChildAccounts?.forEach((account) => {
          if (account.BusinessUserType === "beneficial_owner") {
            const match = responseData.data.find(
              (item) =>
                item.userHandle && account.UserHandle && item.userHandle === account.UserHandle
            );
            if (match) {
              if (id && !account?.IsExisting) {
                setSelectedExistingBeneficialOwner('none')
              } else {
                setSelectedExistingBeneficialOwner(match.investorId);
              }
            } else {
              setSelectedExistingBeneficialOwner('none')
            }
          }
        });
      });
    }
  }, [responseData, userData]);

  const showAllStepErrors = () => {
    const stepName = steps[currentStep];
    const fields = formFieldsByStep[stepName];
    const stepData = formData[stepName];
    let updatedErrors;

    if (stepName === "Beneficial Owner" && !isThisBenificialOwner) {
      setSelectError((prevState) => ({
        ...prevState,
        selectboisadmin: "This field is required"
      }))
      return
    }
    if (stepName === "Beneficial Owner" && isThisBenificialOwner === "no" && !radioControllling && !isThisBenificialOwnerCo) {
      setSelectError((prevState) => ({
        ...prevState,
        selectboisadmin:"",
        selectboisco: "This field is required"
      }))
      return
    }
    if (stepName === "Controlling Officer" && !radioControllling && (selectedExistingUser === null || selectedExistingUser === '')) {
      setSelectError((prevState) => ({
        ...prevState,
        controllingOfficer: "This field is required"
      }))
      return
    }
    if (stepName === "Beneficial Owner" && isThisBenificialOwner == 'no' && ((isThisBenificialOwnerCo == 'no' && !radioControllling) || (!isThisBenificialOwnerCo && radioControllling)) && selectedExistingBeneficialOwner === null) {
      setSelectError((prevState) => ({
        ...prevState,
        benificialsOfficers: "This field is required"
      }))
      return
    }
    if (!fields || !stepData) return;

    if (Array.isArray(stepData)) {
      updatedErrors = stepData.map((entry) => {
        let entryErrors = {};
        const allBlank = Object.values(entry).every(val => val === "" || val == null);
        if (allBlank) return {};
        fields.forEach(({ name }) => {
          const errorMsg = validateField(entry[name], name, benificialPercentage);
          // Always show error if validateField returns an error, even if value is not blank/null
          if (errorMsg) {
            entryErrors[name] = errorMsg;
          } else if (!entry[name] || entry[name] === "" || entry[name] == null) {
            let nameing;
            if (name === "email") {
              nameing = 'Email Address';
            } else if (name === "phone") {
              nameing = 'Phone Number';
            } else if (name === "socialSecurityNumber") {
              nameing = 'Social Security Number';
            } else if (name === 'dateOfBirth') {
              nameing = 'Date of Birth';
            } else if (name === 'documentType') {
              nameing = 'Govt / State issued ID';
            } else if (name === 'zipCode') {
              nameing = 'Zip Code';
            } else if (name === 'percentOwnership') {
              nameing = 'Percent Ownership of Business';
            } else {
              nameing = name.charAt(0).toUpperCase() + name.slice(1);
            }
            entryErrors[name] = `${nameing} is required.`;
          } else {
            delete entryErrors[name];
          }
        });
        // Custom: documentCountry/documentState at least one required
        if (stepName === "Beneficial Owner") {
          if (!entry.documentCountry && !entry.documentState) {
            entryErrors.documentCountry = "Document Country is required";
            entryErrors.documentState = "Document State is required";
          } else {
            // If either is present, clear the other's error
            if (entry.documentCountry) delete entryErrors.documentState;
            if (entry.documentState) delete entryErrors.documentCountry;
          }
        }
        return entryErrors;
      });
    } else {
      updatedErrors = {};
      fields.forEach(({ name }) => {
        const errorMsg = validateField(stepData[name], name, benificialPercentage);
        if (errorMsg) {
          updatedErrors[name] = errorMsg;
        } else if (!stepData[name] || stepData[name] === "" || stepData[name] == null) {
          let nameing;
          if (name === "email") {
            nameing = 'Email Address'
          } else if (name === "phone") {
            nameing = 'Phone Number'
          }
          else if (name === "socialSecurityNumber") {
            nameing = 'Social Security Number'
          } else if (name === 'dateOfBirth') {
            nameing = 'Date of Birth'
          } else if (name === 'documentType') {
            nameing = 'Govt / State issued ID'
          } else if (name === 'zipCode') {
            nameing = 'Zip Code'
          } else {
            nameing = name.charAt(0).toUpperCase() + name.slice(1)
          }
          updatedErrors[name] = `${nameing} is required.`;
        } else {
          delete updatedErrors[name];
        }
      });
      if (stepName === "Administrator" || stepName === "Controlling Officer") {
        const hasState = !!stepData.documentState;
        const hasCountry = !!stepData.documentCountry;
        if (!hasState && !hasCountry) {
          updatedErrors.documentCountry = "Document Country is required";
          updatedErrors.documentState = "Document State is required";
        } else {
          // If either is present, clear the other's error
          if (hasCountry) delete updatedErrors.documentState;
          if (hasState) delete updatedErrors.documentCountry;
        }
      }
    }
    setKycInvestorError((prev) => ({ ...prev, [stepName]: updatedErrors }));
  };

  useEffect(() => {
    if (responseData?.data?.length == 0) {
      setSelectedExistingUser('none')
      setSelectedExistingBeneficialOwner('none')
    }
  }, [responseData?.data])

  return (
    <>
      <Dialog
        open={dialogOpen}
        PaperProps={{
          component: "form",
          style: {
            width: "80%", // Set custom width
            maxWidth: "550px", // Optional: set max width
          },
        }}
      >
        <DialogContent
          sx={{
            textAlign: "center",
            fontSize: 18,
            fontFamily: "Poppins",
            fontWeight: 400,
          }}
        >
          <Box display={"flex"} justifyContent={"center"} my={2}>
            <AccessTimeIcon />
          </Box>
          <Box
            fontSize={"14px"}
            sx={{ color: textColor.fontColor }}
            fontWeight={400}
          >
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: { xs: "1.25rem", md: "17px" },
                color: "text.primary",
                mb: 1,
              }}
              data-testid="verification-title"
            >
              Business Identity Verification In Progress
            </Typography>
            Verification typically completes within a few minutes, but may take few hours in some cases. We'll notify you via email as soon as it's done.<br /> You may close this window and return at your convenience.
          </Box>
          <ButtonComponents
            //loading should be animating loading icon  
            label={"Close"}
            onClick={handleNavigate}
            sx={{
              //if isButtonLoading is true then backgroundColor should be #e65232
              backgroundColor: "#FF5C39",
              color: "#fff",
              height: "40px",
              mt: 2,
              "&:hover": { backgroundColor: "#e65232" },
            }}
            data-testid="Okay-button"
          />

        </DialogContent>
      </Dialog>

      <Dialog
        open={openLoader}
        PaperProps={{
          component: "form",
          style: {
            width: "80%", // Set custom width
            maxWidth: "550px", // Optional: set max width
          },
        }}
      >
        <DialogContent
          sx={{
            textAlign: "center",
            fontSize: 18,
            fontFamily: "Poppins",
            fontWeight: 400,
          }}
        >
          <Box display={"flex"} justifyContent={"center"} my={2}>
            <div className="loader"></div>
          </Box>
          <Box fontSize={"14px"}>
            Submitting your details...
          </Box>

        </DialogContent>
      </Dialog>
      <Dialog
        open={openErrorModel}
        PaperProps={{
          component: "form",
          style: {
            width: "80%", // Set custom width
            maxWidth: "550px", // Optional: set max width
          },
        }}
      >
        <DialogContent
          sx={{
            textAlign: "center",
            fontSize: 18,
            fontFamily: "Poppins",
            fontWeight: 400,
          }}
        >

          <Box
            fontSize={"14px"}
            sx={{ color: textColor.fontColor }}
            fontWeight={400}
            textAlign={"left"}
            my={1}
          >
            There was an issue registering one or more entities. Please review and correct the highlighted fields in the form before resubmitting.
          </Box>
          <Box
            fontSize={"14px"}
            sx={{ color: textColor.fontColor }}
            fontWeight={400}
            textAlign={"left"}
            mb={2}
          >
            <span className="font-semibold">Note</span>: We do not store personally identifiable information (PII), so you may be required to re-enter fields such as EIN, SSN, and Date of Birth.
          </Box>
          <ButtonComponents

            label="OK"
            onClick={() => {
              if (
                isPurchaseProfile
              ) {
                navigate(`/purchaseprofile/identity-verification/${regInvestorId}`)
              } else {
                navigate("/kyc-kyb/identity-verification", {
                  state: { InvestorId: regInvestorId },
                })
              }
              dispatch(initialResetState());
            }}
            sx={{
              backgroundColor: "#FF5C39",
              color: "#fff",
              mt: 2,
              "&:hover": { backgroundColor: "#e65232" },
              my: "auto"
            }}
            data-testid="OK-button"
          />

        </DialogContent>
      </Dialog>
      <Box className="flex justify-center mt-4 pb-8">
        <Box
          className="bg-white p-2 md:p-8 rounded-lg "
          sx={{
            //if location includes "isPurchaseProfile" then width should be 90%
            width: {
              xs: "90%",
              sm: "90%",
              md: isPurchaseProfile ? "90%" : "75%",
              lg: isPurchaseProfile ? "90%" : "50%",
              xl: isPurchaseProfile ? "90%" : "45%",
            },
            justifyContent: "center",
          }}
        >
          <Typography
            className="mb-4"
            mb={1}
            variant="h5"
            align="center"
            fontWeight={600}
            sx={{ fontSize: { xs: "20px", md: "24px" } }}
          >
            Business Information
          </Typography>
          <BreadcrumbComponent
            steps={steps}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />

          {steps[currentStep] === "Controlling Officer" && (
           <>
            <Box gap={2}>
              <FormControl disabled={loginInvestorId && !isPurchaseProfile || id && isPurchaseProfile} >
                <FormLabel
                  id="controlling-officer-label"
                  sx={{
                    mt: 1,
                    color: 'black',
                    '&.Mui-focused': {
                      color: 'black', // Or inherit, or the desired color
                    },
                  }}
                >
                  Are you the Controlling Officer?
                </FormLabel>
                <RadioGroup
                  aria-labelledby="controlling-officer-label"
                  value={radioControllling ? "yes" : "no"}
                  name="controlling-officer"
                  onChange={handleChange}
                  sx={{ display: "block" }}
                >
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
            </>
          )}
          {steps[currentStep] === "Beneficial Owner" && (
            <>
              <Box gap={2} flex flexDirection="column" className="flex flex-col mt-3">
                <FormControl
                  sx={{ mr: 3 }} disabled={isThisBenificialOwnerCo === 'yes' || (loginInvestorId && !isPurchaseProfile) || id && isPurchaseProfile}>
                  <FormLabel
                    id="is-beneficial-owner-label"
                    sx={{
                      color: "#3b3b3b",
                      '&.Mui-focused': {
                        color: "#3b3b3b", // Or inherit, or the desired color
                      },
                    }}
                  >
                    Are you this Beneficial Owner?
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="is-beneficial-owner-label"
                    value={isThisBenificialOwner}
                    name="is-beneficial-owner"
                    onChange={handleChangeIsThisBenificialOwner}
                    sx={{ display: "block" }}
                  >
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                    />
                  </RadioGroup>
                  {selectError.selectboisadmin && (
                    <FormHelperText sx={{ color: '#d32f3f' }}>{selectError.selectboisadmin}</FormHelperText>
                  )}
                </FormControl>
                {isThisBenificialOwner == null && isPurchaseProfile ? <></> : <>
                  {isThisBenificialOwner === 'yes' ? <></> : <>
                    {
                      (!radioControllling && isThisBenificialOwner == 'no') &&
                      <>
                        <FormControl disabled={isThisBenificialOwner === 'yes' || loginInvestorId && !isPurchaseProfile || id && isPurchaseProfile}>
                          <FormLabel
                            id="is-beneficial-owner-label"
                            sx={{
                              color: "#3b3b3b",
                              '&.Mui-focused': {
                                color: "#3b3b3b", // Or inherit, or the desired color
                              },
                            }}
                          >
                            Is this Beneficial Owner the same as the Controlling Officer?
                          </FormLabel>
                          <RadioGroup
                            aria-labelledby="is-beneficial-owner-label"
                            value={isThisBenificialOwnerCo}
                            name="is-beneficial-owner"
                            onChange={handleChangeforCO}
                            sx={{ display: "block" }}
                          >
                            <FormControlLabel
                              value="no"
                              control={<Radio />}
                              label="No"
                            />
                            <FormControlLabel
                              value="yes"
                              control={<Radio />}
                              label="Yes"
                            />
                          </RadioGroup>
                          {selectError.selectboisco && (
                            <FormHelperText sx={{ color: '#d32f3f' }}>{selectError.selectboisco}</FormHelperText>
                          )}
                        </FormControl>
                      </>
                    }

                  </>}
                </>
                }
              </Box>
            </>
          )}

          {shift ? (
            <Loading height="300px" />
          ) : (
            <div className="my-3 ">
              {(steps[currentStep] == "Controlling Officer") ? (
                <>
                  {
                    radioControllling && isPurchaseProfile ? (
                      <></>
                    ) :       existingUserLoading? <Loading height="300px" />:
                      <>
                        {
                          !radioControllling &&
                          responseData?.data?.length > 0 &&
                          <FormControl
                          error={!!selectError.controllingOfficer}
                          sx={{
                            width: {
                              xs: "100%",  // mobile
                              sm: "80%",   // small tablets
                              md: "60%",   // desktops
                              lg: "40%",   // large desktops
                              xl: "30%",   // extra large screens
                            },
                            mb: '10px'
                          }}
                        >
                          <Typography sx={{marginBottom: '6px' }}>Is the Controlling Officer one of these?</Typography>
                          <Select
                            value={selectedExistingUser}
                            disabled={id}
                            onChange={(e) => {
                              const value = e.target.value;
                              setSelectedExistingUser(value);
                              setSelectError(prev => ({...prev, controllingOfficer: ""}))
                              handleResetErrors("Controlling Officer");
                              if (value === 'none') {
                                setFormData((prev) => ({
                                  ...prev,
                                  "Controlling Officer": {
                                    investorId: 0,
                                    firstName: "",
                                    lastName: "",
                                    address: "",
                                    city: "",
                                    state: "",
                                    zipCode: "",
                                    dateOfBirth: "",
                                    socialSecurityNumber: "",
                                    email: "",
                                    phone: "",
                                    documentId: "",
                                    documentType: "",
                                    documentState: "",
                                    documentCountry: "",
                                    IsExistingUser: false,
                                  },
                                }));
                              }
                            }}
                            displayEmpty
                          >
                            <MenuItem value="null" disabled>
                              Select below
                            </MenuItem>
                            {Array.isArray(responseData?.data) && responseData?.data?.map((item) => (
                              <MenuItem key={item.id || item.investorId} value={item.id || item.investorId}>
                                {item.firstName} {item.lastName}
                              </MenuItem>
                            ))}
                            <MenuItem value="none">None of these</MenuItem>
                          </Select>
                          {selectError.controllingOfficer && <FormHelperText>{selectError.controllingOfficer}</FormHelperText>}
                        </FormControl>

                        }
                        <>
                        
                        {selectedExistingUser == 'none' && 
                        <>
                        {existingUserLoading ? 
                        <Box >
                        <Loading height="51.5vh"/> 
                        </Box>
                        :
                          <FormComponent
                            radioControllling={
                              steps[currentStep] === "Controlling Officer"
                                ? radioControllling
                                : steps[currentStep] === "Beneficial Owner" && ((isThisBenificialOwner === "yes" || isThisBenificialOwnerCo === "yes") ? true : false)
                            }
                            isUpdate={
                              isPurchaseProfile ? false : loginInvestorId ? true : false
                            }
                            formFields={formFieldsByStep[steps[currentStep]]}
                            title={steps[currentStep]}
                            formData={formData}
                            handleInputChange={handleInputChange}
                            handleAddOwner={handleAddOwner}
                            handleRemoveOwner={handleRemoveOwner}
                            isPurchaseProfile={isPurchaseProfile}
                            errors={
                              kycInvestorError[steps[currentStep]]
                            }
                            size={isPurchaseProfile ? "big" : "small"}
                          />
                          }
                          </>
                        }
                        </>

                      </>
                  }

                </>
              ) :
                         existingUserLoading? <Loading height="300px" />:
                <>

                  {steps[currentStep] === "Beneficial Owner" && responseData?.data?.length > 0 &&
                    ((isThisBenificialOwner == 'no' && ((isThisBenificialOwnerCo == 'no' && !radioControllling) || (!isThisBenificialOwnerCo && radioControllling)) || (radioControllling && isThisBenificialOwner == 'no'))) &&
                    (

                      <FormControl
                      error={!!selectError.benificialsOfficers}
                      sx={{
                        width: {
                          xs: "100%",
                          sm: "80%",
                          md: "60%",
                          lg: "40%",
                          xl: "30%",
                        },
                        mb: '10px'
                      }}
                    >
                      <Typography sx={{marginBottom: '6px'}}>
                      Is the Beneficial Owner one of these?
                      </Typography>
                      <Select
                        value={selectedExistingBeneficialOwner}
                        disabled={id}
                        onChange={(e) => {
                          const value = e.target.value;
                          setSelectedExistingBeneficialOwner(value);
                          handleResetErrors("Beneficial Owner");
                          setSelectError(prev => ({...prev, benificialsOfficers: ""}))
                            setFormData((prev) => ({
                              ...prev,
                              "Beneficial Owner": [
                                {
                                  investorId: 0,
                                  firstName: "",
                                  lastName: "",
                                  address: "",
                                  city: "",
                                  state: "",
                                  zipCode: "",
                                  dateOfBirth: "",
                                  socialSecurityNumber: "",
                                  email: "",
                                  phone: "",
                                  documentId: "",
                                  documentType: "",
                                  documentState: "",
                                  documentCountry: "",
                                  percentOwnership: "",
                                  IsExistingUser: false,
                                },
                              ],
                            }));
                        }}
                        displayEmpty
                      >
                        <MenuItem value="null" disabled>
                        Select below
                        </MenuItem>
                        {Array.isArray(responseData?.data) && responseData?.data
                          .filter(item => String(item.id || item.investorId) !== String(selectedExistingUser))
                          .map((item) => (
                            <MenuItem key={item.id || item.investorId} value={item.id || item.investorId}>
                              {item.firstName}{" "}{item.lastName}
                            </MenuItem>
                          ))}
                        <MenuItem value="none">None of these</MenuItem>
                      </Select>
                      {selectError.benificialsOfficers && <FormHelperText>{selectError.benificialsOfficers}</FormHelperText>}
                    </FormControl>
                    
                    )


                  }
                  {
                    // Move the showFormComponent logic above JSX
                  }
                  {(() => {
                    let showFormComponent = true;

                    if (responseData?.data?.length == 0) {
                      if (radioControllling == 'yes' && isThisBenificialOwner == null || radioControllling == false && isThisBenificialOwner == 'no' && isThisBenificialOwnerCo == null && responseData?.data.length == 0) {
                        showFormComponent = false;
                      } else if (radioControllling && isThisBenificialOwner == 'no' && isThisBenificialOwnerCo == null && responseData?.data?.length == 0 || radioControllling == true && isThisBenificialOwner == 'no' && isThisBenificialOwnerCo == 'no' && responseData?.data.length == 0) {
                        showFormComponent = true;
                      } else if (isThisBenificialOwner == null && isThisBenificialOwnerCo == null) {
                        showFormComponent = false;
                      }
                    }

                    else if (isThisBenificialOwner !== 'yes') {
                      if (
                        (!radioControllling &&
                          (isThisBenificialOwnerCo === "no" &&
                            selectedExistingBeneficialOwner === null) || (!isThisBenificialOwner && !isThisBenificialOwnerCo)) ||
                        (isThisBenificialOwner == 'no' && !radioControllling && !isThisBenificialOwnerCo) || (isThisBenificialOwner == 'no' && radioControllling && selectedExistingBeneficialOwner === null)
                      ) {
                        showFormComponent = false;
                      }
                    } else if (radioControllling && isThisBenificialOwner == 'no' && responseData?.data?.length < 0) {
                      showFormComponent = true;
                    } else if (!radioControllling && isThisBenificialOwner == 'no' && isThisBenificialOwnerCo == 'no' && responseData?.data.length < 0) {
                      showFormComponent = true;
                    } else {
                      // If isThisBenificialOwner === 'yes' the showFormComponent remains true
                      showFormComponent = true;
                    }
                    if (!showFormComponent) return null;
                    return ( 
                      <FormComponent
                        radioControllling={
                          steps[currentStep] === "Controlling Officer"
                            ? radioControllling
                            : steps[currentStep] === "Beneficial Owner" && ((isThisBenificialOwner === "yes" || isThisBenificialOwnerCo === "yes") ? true : false)
                        }
                        isUpdate={
                          isPurchaseProfile ? false : loginInvestorId ? true : false
                        }
                        ishideField={(isThisBenificialOwner == 'no' && isThisBenificialOwnerCo == 'yes') || isThisBenificialOwner == "yes" || (selectedExistingBeneficialOwner !== null && selectedExistingBeneficialOwner !== 'none')}
                        formFields={formFieldsByStep[steps[currentStep]]}
                        title={steps[currentStep]}
                        formData={formData}
                        handleInputChange={handleInputChange}
                        handleAddOwner={handleAddOwner}
                        handleRemoveOwner={handleRemoveOwner}
                        isPurchaseProfile={isPurchaseProfile}
                        errors={
                          kycInvestorError[steps[currentStep]]
                        }
                        size={isPurchaseProfile ? "big" : "small"}
                      />
                    );
                  })()}
                </>
              }
            </div>
          )}
          <>
            {!shift && (
              existingUserLoading?"":(
              <Box className="flex gap-4" sx={{ justifyContent: "center" }}>
                <Button
                  variant="outlined"
                  sx={{ color: "#FF5C39", borderColor: "#FF5C39", textTransform: 'none' }}
                  onClick={handlePreviousStep}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: isFormValid ? "#FF5C39" : "#9fa4ab",
                    textTransform: 'none',
                    backgroundColor: isFormValid ? "#FF5C39" : "#9fa4ab",
                    color: "#fff",
                    boxShadow: !isFormValid ? "none" : undefined,
                    border: !isFormValid ? "1px solid transparent" : undefined,
                    // cursor: isFormValid ? 'pointer' : 'not-allowed',
                    opacity: isFormValid ? 1 : 0.7,
                    '&:hover': {
                      backgroundColor: isFormValid ? "#e65232" : "#9fa4ab",
                      border: !isFormValid ? "1px solid transparent" : undefined,
                      boxShadow: !isFormValid ? "none" : undefined,
                    },
                  }}
                  // disabled={!isFormValid}
                  onClick={() => {
                    if (!isFormValid) {
                      showAllStepErrors();
                    } else {
                      const stepName = steps[currentStep];
                      const isValid = validateFormData(formData, stepName);
                      if (isValid) handleNextStep();
                    }
                  }}
                >
                  {currentStep === steps?.length - 1 ? "Submit" : "Next"}
                </Button>

              </Box>)

            )}
            {
              steps[currentStep] === "Administrator" && (
                <Box>
                  <Typography sx={{ fontSize: '14px' }} className="italic pt-4 pb-4">
                    Administrator refers to the individual initiating the business verification on behalf of the company. In this case, this is you.                </Typography>
                </Box>
              )
            }
            {
              steps[currentStep] === "Controlling Officer" && (
                <Box>
                  <Typography sx={{ fontSize: '14px' }} className="italic pt-4 pb-4">
                    Controlling Officers must be a principal of the company with the authority to bind the company specifically by delegation in the company's organizational documents (or by action of the board, voting members, partners, etc.). In other words, Controlling Officers are individuals with leadership positions and have the ability to sign contracts for the business.
                  </Typography>
                </Box>
              )
            }
            {
              steps[currentStep] === "Beneficial Owner" && (
                <Box>
                  <Typography sx={{ fontSize: '14px' }} className="italic pt-4 pb-4">
                    Beneficial Owners are those with a {bussinessUserdata?.BusinessTypeId == "1" ? "100%" : "50%+"} stake in the business. If the business is owned by another entity, designate a representative and enter their information for verification.                </Typography>
                </Box>
              )
            }
          </>
        </Box>



      </Box>
    </>
  );
};

export default PurchaseProfileBusinessInfo;
